{
    "data": [
        {
            "title": "   433 Eros (A898 PA)",
            "a": 1.458,
            "i": 10.83,
            "e": 0.2227,
            "peri": 178.91,
            "M": 86.67,
            "period": 643,
            "q": 1.133,
            "Q": 1.78,
            "NEO": "Y",
            "PHA": "N",
            "aN": 304.27
        },
        {
            "title": "   719 Albert (A911 TB)",
            "a": 2.636,
            "i": 11.58,
            "e": 0.5468,
            "peri": 156.22,
            "M": 148.45,
            "period": 1560,
            "q": 1.195,
            "Q": 4.08,
            "NEO": "Y",
            "PHA": "N",
            "aN": 183.86
        },
        {
            "title": "   887 Alinda (A918 AA)",
            "a": 2.473,
            "i": 9.4,
            "e": 0.5711,
            "peri": 350.47,
            "M": 340.2,
            "period": 1420,
            "q": 1.06,
            "Q": 3.88,
            "NEO": "Y",
            "PHA": "N",
            "aN": 110.42
        },
        {
            "title": "  1036 Ganymed (A924 UB)",
            "a": 2.665,
            "i": 26.69,
            "e": 0.5328,
            "peri": 132.5,
            "M": 6.98,
            "period": 1590,
            "q": 1.245,
            "Q": 4.09,
            "NEO": "Y",
            "PHA": "N",
            "aN": 215.49
        },
        {
            "title": "  1221 Amor (1932 EA1)",
            "a": 1.92,
            "i": 11.87,
            "e": 0.4347,
            "peri": 26.72,
            "M": 271.7,
            "period": 972,
            "q": 1.085,
            "Q": 2.75,
            "NEO": "Y",
            "PHA": "N",
            "aN": 171.26
        },
        {
            "title": "  1566 Icarus (1949 MA)",
            "a": 1.078,
            "i": 22.8,
            "e": 0.827,
            "peri": 31.43,
            "M": 160.86,
            "period": 409,
            "q": 0.187,
            "Q": 1.97,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 87.95
        },
        {
            "title": "  1580 Betulia (1950 KA)",
            "a": 2.195,
            "i": 52.19,
            "e": 0.4876,
            "peri": 159.73,
            "M": 319.03,
            "period": 1190,
            "q": 1.125,
            "Q": 3.27,
            "NEO": "Y",
            "PHA": "N",
            "aN": 62.23
        },
        {
            "title": "  1620 Geographos (1951 RA)",
            "a": 1.246,
            "i": 13.34,
            "e": 0.3356,
            "peri": 277.01,
            "M": 289.36,
            "period": 508,
            "q": 0.828,
            "Q": 1.66,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 337.15
        },
        {
            "title": "  1627 Ivar (1929 SH)",
            "a": 1.863,
            "i": 8.45,
            "e": 0.397,
            "peri": 167.84,
            "M": 156.41,
            "period": 929,
            "q": 1.124,
            "Q": 2.6,
            "NEO": "Y",
            "PHA": "N",
            "aN": 133.08
        },
        {
            "title": "  1685 Toro (1948 OA)",
            "a": 1.368,
            "i": 9.38,
            "e": 0.4361,
            "peri": 127.27,
            "M": 196.26,
            "period": 584,
            "q": 0.771,
            "Q": 1.96,
            "NEO": "Y",
            "PHA": "N",
            "aN": 274.21
        },
        {
            "title": "  1862 Apollo (1932 HA)",
            "a": 1.471,
            "i": 6.35,
            "e": 0.5599,
            "peri": 286.03,
            "M": 252.87,
            "period": 651,
            "q": 0.647,
            "Q": 2.29,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 35.56
        },
        {
            "title": "  1863 Antinous (1948 EA)",
            "a": 2.261,
            "i": 18.35,
            "e": 0.6063,
            "peri": 268.57,
            "M": 173.83,
            "period": 1240,
            "q": 0.89,
            "Q": 3.63,
            "NEO": "Y",
            "PHA": "N",
            "aN": 346
        },
        {
            "title": "  1864 Daedalus (1971 FA)",
            "a": 1.461,
            "i": 22.21,
            "e": 0.6143,
            "peri": 325.66,
            "M": 34.28,
            "period": 645,
            "q": 0.564,
            "Q": 2.36,
            "NEO": "Y",
            "PHA": "N",
            "aN": 6.61
        },
        {
            "title": "  1865 Cerberus (1971 UA)",
            "a": 1.08,
            "i": 16.1,
            "e": 0.4668,
            "peri": 325.29,
            "M": 328.39,
            "period": 410,
            "q": 0.576,
            "Q": 1.58,
            "NEO": "Y",
            "PHA": "N",
            "aN": 212.89
        },
        {
            "title": "  1866 Sisyphus (1972 XA)",
            "a": 1.894,
            "i": 41.21,
            "e": 0.538,
            "peri": 293.12,
            "M": 349.34,
            "period": 952,
            "q": 0.875,
            "Q": 2.91,
            "NEO": "Y",
            "PHA": "N",
            "aN": 63.45
        },
        {
            "title": "  1915 Quetzalcoatl (1953 EA)",
            "a": 2.544,
            "i": 20.4,
            "e": 0.5703,
            "peri": 347.77,
            "M": 284.48,
            "period": 1480,
            "q": 1.093,
            "Q": 4,
            "NEO": "Y",
            "PHA": "N",
            "aN": 162.93
        },
        {
            "title": "  1916 Boreas (1953 RA)",
            "a": 2.273,
            "i": 12.88,
            "e": 0.4493,
            "peri": 335.86,
            "M": 280.05,
            "period": 1250,
            "q": 1.252,
            "Q": 3.29,
            "NEO": "Y",
            "PHA": "N",
            "aN": 340.6
        },
        {
            "title": "  1917 Cuyo (1968 AA)",
            "a": 2.149,
            "i": 23.96,
            "e": 0.5057,
            "peri": 194.56,
            "M": 34.92,
            "period": 1150,
            "q": 1.062,
            "Q": 3.24,
            "NEO": "Y",
            "PHA": "N",
            "aN": 188.28
        },
        {
            "title": "  1943 Anteros (1973 EC)",
            "a": 1.43,
            "i": 8.71,
            "e": 0.2561,
            "peri": 338.46,
            "M": 29.9,
            "period": 625,
            "q": 1.064,
            "Q": 1.8,
            "NEO": "Y",
            "PHA": "N",
            "aN": 246.3
        },
        {
            "title": "  1980 Tezcatlipoca (1950 LA)",
            "a": 1.71,
            "i": 26.87,
            "e": 0.3647,
            "peri": 115.51,
            "M": 35.06,
            "period": 817,
            "q": 1.086,
            "Q": 2.33,
            "NEO": "Y",
            "PHA": "N",
            "aN": 246.54
        },
        {
            "title": "  1981 Midas (1973 EA)",
            "a": 1.776,
            "i": 39.82,
            "e": 0.6505,
            "peri": 267.84,
            "M": 258.81,
            "period": 865,
            "q": 0.621,
            "Q": 2.93,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 356.8
        },
        {
            "title": "  2059 Baboquivari (1963 UA)",
            "a": 2.642,
            "i": 11.02,
            "e": 0.5318,
            "peri": 192.45,
            "M": 51.33,
            "period": 1570,
            "q": 1.237,
            "Q": 4.05,
            "NEO": "Y",
            "PHA": "N",
            "aN": 200.69
        },
        {
            "title": "  2061 Anza (1960 UA)",
            "a": 2.265,
            "i": 3.8,
            "e": 0.5356,
            "peri": 157.09,
            "M": 283.26,
            "period": 1250,
            "q": 1.052,
            "Q": 3.48,
            "NEO": "Y",
            "PHA": "N",
            "aN": 207.36
        },
        {
            "title": "  2062 Aten (1976 AA)",
            "a": 0.967,
            "i": 18.93,
            "e": 0.1829,
            "peri": 148.06,
            "M": 338.03,
            "period": 347,
            "q": 0.79,
            "Q": 1.14,
            "NEO": "Y",
            "PHA": "N",
            "aN": 108.53
        },
        {
            "title": "  2063 Bacchus (1977 HB)",
            "a": 1.078,
            "i": 9.44,
            "e": 0.3494,
            "peri": 55.34,
            "M": 242.55,
            "period": 409,
            "q": 0.701,
            "Q": 1.45,
            "NEO": "Y",
            "PHA": "N",
            "aN": 33.04
        },
        {
            "title": "  2100 Ra-Shalom (1978 RA)",
            "a": 0.832,
            "i": 15.75,
            "e": 0.4365,
            "peri": 356.08,
            "M": 89.62,
            "period": 277,
            "q": 0.469,
            "Q": 1.2,
            "NEO": "Y",
            "PHA": "N",
            "aN": 170.78
        },
        {
            "title": "  2101 Adonis (1936 CA)",
            "a": 1.874,
            "i": 1.32,
            "e": 0.7642,
            "peri": 43.69,
            "M": 230.82,
            "period": 937,
            "q": 0.442,
            "Q": 3.31,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 349.43
        },
        {
            "title": "  2102 Tantalus (1975 YA)",
            "a": 1.29,
            "i": 64,
            "e": 0.2993,
            "peri": 61.52,
            "M": 78.27,
            "period": 535,
            "q": 0.904,
            "Q": 1.68,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 94.35
        },
        {
            "title": "  2135 Aristaeus (1977 HA)",
            "a": 1.6,
            "i": 23.07,
            "e": 0.503,
            "peri": 290.97,
            "M": 202.31,
            "period": 739,
            "q": 0.795,
            "Q": 2.4,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 191.11
        },
        {
            "title": "  2201 Oljato (1947 XC)",
            "a": 2.179,
            "i": 2.52,
            "e": 0.7107,
            "peri": 98.37,
            "M": 334.42,
            "period": 1170,
            "q": 0.63,
            "Q": 3.73,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 74.87
        },
        {
            "title": "  2202 Pele (1972 RA)",
            "a": 2.291,
            "i": 8.74,
            "e": 0.5128,
            "peri": 217.99,
            "M": 355.86,
            "period": 1270,
            "q": 1.116,
            "Q": 3.47,
            "NEO": "Y",
            "PHA": "N",
            "aN": 169.91
        },
        {
            "title": "  2212 Hephaistos (1978 SB)",
            "a": 2.166,
            "i": 11.31,
            "e": 0.8361,
            "peri": 210.05,
            "M": 184.81,
            "period": 1160,
            "q": 0.355,
            "Q": 3.98,
            "NEO": "Y",
            "PHA": "N",
            "aN": 27.01
        },
        {
            "title": "  2329 Orthos (1976 WA)",
            "a": 2.41,
            "i": 24.46,
            "e": 0.6533,
            "peri": 146.05,
            "M": 325.99,
            "period": 1370,
            "q": 0.836,
            "Q": 3.99,
            "NEO": "Y",
            "PHA": "N",
            "aN": 169.28
        },
        {
            "title": "  2340 Hathor (1976 UA)",
            "a": 0.8438,
            "i": 5.86,
            "e": 0.45,
            "peri": 40.1,
            "M": 53.4,
            "period": 283,
            "q": 0.464,
            "Q": 1.22,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 211.29
        },
        {
            "title": "  2368 Beltrovata (1977 RA)",
            "a": 2.105,
            "i": 5.22,
            "e": 0.4135,
            "peri": 43.07,
            "M": 158.64,
            "period": 1120,
            "q": 1.234,
            "Q": 2.97,
            "NEO": "Y",
            "PHA": "N",
            "aN": 287.29
        },
        {
            "title": "  2608 Seneca (1978 DA)",
            "a": 2.532,
            "i": 14.43,
            "e": 0.5651,
            "peri": 38.59,
            "M": 272.88,
            "period": 1470,
            "q": 1.101,
            "Q": 3.96,
            "NEO": "Y",
            "PHA": "N",
            "aN": 166.52
        },
        {
            "title": "  3102 Krok (1981 QA)",
            "a": 2.151,
            "i": 8.44,
            "e": 0.4493,
            "peri": 154.77,
            "M": 241.78,
            "period": 1150,
            "q": 1.185,
            "Q": 3.12,
            "NEO": "Y",
            "PHA": "N",
            "aN": 172.05
        },
        {
            "title": "  3103 Eger (1982 BB)",
            "a": 1.404,
            "i": 20.93,
            "e": 0.3542,
            "peri": 254.12,
            "M": 304.12,
            "period": 608,
            "q": 0.907,
            "Q": 1.9,
            "NEO": "Y",
            "PHA": "N",
            "aN": 129.73
        },
        {
            "title": "  3122 Florence (1981 ET3)",
            "a": 1.769,
            "i": 22.14,
            "e": 0.4231,
            "peri": 27.9,
            "M": 0.67,
            "period": 859,
            "q": 1.021,
            "Q": 2.52,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 336.05
        },
        {
            "title": "  3199 Nefertiti (1982 RA)",
            "a": 1.574,
            "i": 32.96,
            "e": 0.2842,
            "peri": 53.43,
            "M": 78.94,
            "period": 722,
            "q": 1.127,
            "Q": 2.02,
            "NEO": "Y",
            "PHA": "N",
            "aN": 339.98
        },
        {
            "title": "  3200 Phaethon (1983 TB)",
            "a": 1.271,
            "i": 22.31,
            "e": 0.8898,
            "peri": 322.31,
            "M": 248.98,
            "period": 524,
            "q": 0.14,
            "Q": 2.4,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 265.1
        },
        {
            "title": "  3271 Ul (1982 RB)",
            "a": 2.102,
            "i": 25.07,
            "e": 0.3956,
            "peri": 159.08,
            "M": 304.61,
            "period": 1110,
            "q": 1.27,
            "Q": 2.93,
            "NEO": "Y",
            "PHA": "N",
            "aN": 158.81
        },
        {
            "title": "  3288 Seleucus (1982 DV)",
            "a": 2.035,
            "i": 5.93,
            "e": 0.4549,
            "peri": 349.35,
            "M": 241.11,
            "period": 1060,
            "q": 1.109,
            "Q": 2.96,
            "NEO": "Y",
            "PHA": "N",
            "aN": 218.61
        },
        {
            "title": "  3352 McAuliffe (1981 CW)",
            "a": 1.879,
            "i": 4.77,
            "e": 0.3691,
            "peri": 16.07,
            "M": 347.84,
            "period": 941,
            "q": 1.185,
            "Q": 2.57,
            "NEO": "Y",
            "PHA": "N",
            "aN": 107.33
        },
        {
            "title": "  3360 Syrinx (1981 VA)",
            "a": 2.468,
            "i": 21.14,
            "e": 0.7457,
            "peri": 63.56,
            "M": 49.58,
            "period": 1420,
            "q": 0.628,
            "Q": 4.31,
            "NEO": "Y",
            "PHA": "N",
            "aN": 242.46
        },
        {
            "title": "  3361 Orpheus (1982 HR)",
            "a": 1.21,
            "i": 2.66,
            "e": 0.3229,
            "peri": 302.34,
            "M": 24.54,
            "period": 486,
            "q": 0.82,
            "Q": 1.6,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 188.68
        },
        {
            "title": "  3362 Khufu (1984 QA)",
            "a": 0.9895,
            "i": 9.92,
            "e": 0.4685,
            "peri": 55.09,
            "M": 359.85,
            "period": 360,
            "q": 0.526,
            "Q": 1.45,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 152.4
        },
        {
            "title": "  3551 Verenia (1983 RD)",
            "a": 2.093,
            "i": 9.51,
            "e": 0.487,
            "peri": 193.3,
            "M": 203.09,
            "period": 1110,
            "q": 1.074,
            "Q": 3.11,
            "NEO": "Y",
            "PHA": "N",
            "aN": 173.78
        },
        {
            "title": "  3552 Don Quixote (1983 SA)",
            "a": 4.267,
            "i": 31.06,
            "e": 0.7073,
            "peri": 316.53,
            "M": 263.48,
            "period": 3220,
            "q": 1.249,
            "Q": 7.29,
            "NEO": "Y",
            "PHA": "N",
            "aN": 349.96
        },
        {
            "title": "  3553 Mera (1985 JA)",
            "a": 1.645,
            "i": 36.78,
            "e": 0.3199,
            "peri": 288.88,
            "M": 289.71,
            "period": 770,
            "q": 1.118,
            "Q": 2.17,
            "NEO": "Y",
            "PHA": "N",
            "aN": 232.49
        },
        {
            "title": "  3554 Amun (1986 EB)",
            "a": 0.974,
            "i": 23.36,
            "e": 0.2806,
            "peri": 359.42,
            "M": 226.57,
            "period": 351,
            "q": 0.701,
            "Q": 1.25,
            "NEO": "Y",
            "PHA": "N",
            "aN": 358.6
        },
        {
            "title": "  3671 Dionysus (1984 KD)",
            "a": 2.2,
            "i": 13.54,
            "e": 0.542,
            "peri": 204.33,
            "M": 131.35,
            "period": 1190,
            "q": 1.008,
            "Q": 3.39,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 82.05
        },
        {
            "title": "  3691 Bede (1982 FT)",
            "a": 1.774,
            "i": 20.35,
            "e": 0.2844,
            "peri": 235.08,
            "M": 345.07,
            "period": 863,
            "q": 1.27,
            "Q": 2.28,
            "NEO": "Y",
            "PHA": "N",
            "aN": 348.7
        },
        {
            "title": "  3752 Camillo (1985 PA)",
            "a": 1.414,
            "i": 55.56,
            "e": 0.3016,
            "peri": 312.22,
            "M": 8.79,
            "period": 614,
            "q": 0.987,
            "Q": 1.84,
            "NEO": "Y",
            "PHA": "N",
            "aN": 147.96
        },
        {
            "title": "  3753 Cruithne (1986 TO)",
            "a": 0.9978,
            "i": 19.8,
            "e": 0.5148,
            "peri": 43.88,
            "M": 308.8,
            "period": 364,
            "q": 0.484,
            "Q": 1.51,
            "NEO": "Y",
            "PHA": "N",
            "aN": 126.19
        },
        {
            "title": "  3757 Anagolay (1982 XB)",
            "a": 1.834,
            "i": 3.87,
            "e": 0.4459,
            "peri": 17.24,
            "M": 293.7,
            "period": 908,
            "q": 1.017,
            "Q": 2.65,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 74.93
        },
        {
            "title": "  3838 Epona (1986 WA)",
            "a": 1.505,
            "i": 29.2,
            "e": 0.7027,
            "peri": 49.72,
            "M": 225.76,
            "period": 674,
            "q": 0.447,
            "Q": 2.56,
            "NEO": "Y",
            "PHA": "N",
            "aN": 235.47
        },
        {
            "title": "  3908 Nyx (1980 PA)",
            "a": 1.928,
            "i": 2.19,
            "e": 0.4592,
            "peri": 126.65,
            "M": 165.71,
            "period": 978,
            "q": 1.042,
            "Q": 2.81,
            "NEO": "Y",
            "PHA": "N",
            "aN": 261.2
        },
        {
            "title": "  3988 Huma (1986 LA)",
            "a": 1.545,
            "i": 10.77,
            "e": 0.3166,
            "peri": 86.91,
            "M": 316.36,
            "period": 701,
            "q": 1.056,
            "Q": 2.03,
            "NEO": "Y",
            "PHA": "N",
            "aN": 229.79
        },
        {
            "title": "  4015 Wilson-Harrington (1979 VA)",
            "a": 2.626,
            "i": 2.8,
            "e": 0.6312,
            "peri": 95.52,
            "M": 181.75,
            "period": 1550,
            "q": 0.968,
            "Q": 4.28,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 266.73
        },
        {
            "title": "  4034 Vishnu (1986 PA)",
            "a": 1.06,
            "i": 11.17,
            "e": 0.4441,
            "peri": 296.7,
            "M": 260.4,
            "period": 398,
            "q": 0.589,
            "Q": 1.53,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 157.89
        },
        {
            "title": "  4055 Magellan (1985 DO2)",
            "a": 1.82,
            "i": 23.25,
            "e": 0.3261,
            "peri": 154.38,
            "M": 267.34,
            "period": 897,
            "q": 1.227,
            "Q": 2.41,
            "NEO": "Y",
            "PHA": "N",
            "aN": 164.82
        },
        {
            "title": "  4179 Toutatis (1989 AC)",
            "a": 2.543,
            "i": 0.45,
            "e": 0.6248,
            "peri": 277.88,
            "M": 339.68,
            "period": 1480,
            "q": 0.954,
            "Q": 4.13,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 125.36
        },
        {
            "title": "  4183 Cuno (1959 LM)",
            "a": 1.981,
            "i": 6.67,
            "e": 0.6361,
            "peri": 237.02,
            "M": 175.91,
            "period": 1020,
            "q": 0.721,
            "Q": 3.24,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 294.35
        },
        {
            "title": "  4197 Morpheus (1982 TA)",
            "a": 2.295,
            "i": 12.6,
            "e": 0.7724,
            "peri": 122.55,
            "M": 357.11,
            "period": 1270,
            "q": 0.522,
            "Q": 4.07,
            "NEO": "Y",
            "PHA": "N",
            "aN": 7.01
        },
        {
            "title": "  4257 Ubasti (1987 QA)",
            "a": 1.647,
            "i": 40.72,
            "e": 0.4683,
            "peri": 278.94,
            "M": 160.95,
            "period": 772,
            "q": 0.876,
            "Q": 2.42,
            "NEO": "Y",
            "PHA": "N",
            "aN": 169.15
        },
        {
            "title": "  4341 Poseidon (1987 KF)",
            "a": 1.834,
            "i": 11.84,
            "e": 0.68,
            "peri": 15.83,
            "M": 44.04,
            "period": 907,
            "q": 0.587,
            "Q": 3.08,
            "NEO": "Y",
            "PHA": "N",
            "aN": 108.03
        },
        {
            "title": "  4401 Aditi (1985 TB)",
            "a": 2.584,
            "i": 26.63,
            "e": 0.5633,
            "peri": 68.15,
            "M": 133.5,
            "period": 1520,
            "q": 1.128,
            "Q": 4.04,
            "NEO": "Y",
            "PHA": "N",
            "aN": 22.78
        },
        {
            "title": "  4450 Pan (1987 SY)",
            "a": 1.443,
            "i": 5.52,
            "e": 0.5866,
            "peri": 291.94,
            "M": 192.17,
            "period": 633,
            "q": 0.596,
            "Q": 2.29,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 311.7
        },
        {
            "title": "  4486 Mithra (1987 SB)",
            "a": 2.205,
            "i": 3.04,
            "e": 0.662,
            "peri": 169.12,
            "M": 156.61,
            "period": 1200,
            "q": 0.745,
            "Q": 3.67,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 82.18
        },
        {
            "title": "  4487 Pocahontas (1987 UA)",
            "a": 1.73,
            "i": 16.41,
            "e": 0.2966,
            "peri": 173.99,
            "M": 95.85,
            "period": 831,
            "q": 1.217,
            "Q": 2.24,
            "NEO": "Y",
            "PHA": "N",
            "aN": 198.1
        },
        {
            "title": "  4503 Cleobulus (1989 WM)",
            "a": 2.703,
            "i": 2.51,
            "e": 0.5247,
            "peri": 76.25,
            "M": 287.79,
            "period": 1620,
            "q": 1.285,
            "Q": 4.12,
            "NEO": "Y",
            "PHA": "N",
            "aN": 45.94
        },
        {
            "title": "  4544 Xanthus (1989 FB)",
            "a": 1.042,
            "i": 14.14,
            "e": 0.2501,
            "peri": 333.83,
            "M": 354.5,
            "period": 388,
            "q": 0.781,
            "Q": 1.3,
            "NEO": "Y",
            "PHA": "N",
            "aN": 23.95
        },
        {
            "title": "  4581 Asclepius (1989 FC)",
            "a": 1.023,
            "i": 4.92,
            "e": 0.357,
            "peri": 255.38,
            "M": 212.12,
            "period": 378,
            "q": 0.658,
            "Q": 1.39,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 180.2
        },
        {
            "title": "  4596 (1981 QB)",
            "a": 2.24,
            "i": 37.07,
            "e": 0.52,
            "peri": 248.42,
            "M": 290.19,
            "period": 1220,
            "q": 1.075,
            "Q": 3.4,
            "NEO": "Y",
            "PHA": "N",
            "aN": 154.19
        },
        {
            "title": "  4660 Nereus (1982 DB)",
            "a": 1.485,
            "i": 1.45,
            "e": 0.3587,
            "peri": 159.54,
            "M": 191.96,
            "period": 661,
            "q": 0.952,
            "Q": 2.02,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 313.11
        },
        {
            "title": "  4688 (1980 WF)",
            "a": 2.232,
            "i": 6.38,
            "e": 0.5179,
            "peri": 213.8,
            "M": 45.35,
            "period": 1220,
            "q": 1.076,
            "Q": 3.39,
            "NEO": "Y",
            "PHA": "N",
            "aN": 241.23
        },
        {
            "title": "  4769 Castalia (1989 PB)",
            "a": 1.063,
            "i": 8.88,
            "e": 0.4832,
            "peri": 121.44,
            "M": 324.11,
            "period": 400,
            "q": 0.549,
            "Q": 1.58,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 325.51
        },
        {
            "title": "  4947 Ninkasi (1988 TJ1)",
            "a": 1.37,
            "i": 15.65,
            "e": 0.1685,
            "peri": 192.93,
            "M": 144.57,
            "period": 586,
            "q": 1.139,
            "Q": 1.6,
            "NEO": "Y",
            "PHA": "N",
            "aN": 215.43
        },
        {
            "title": "  4953 (1990 MU)",
            "a": 1.621,
            "i": 24.38,
            "e": 0.6574,
            "peri": 77.93,
            "M": 285.02,
            "period": 754,
            "q": 0.555,
            "Q": 2.69,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 77.53
        },
        {
            "title": "  4954 Eric (1990 SQ)",
            "a": 2.001,
            "i": 17.43,
            "e": 0.4494,
            "peri": 52.62,
            "M": 347.92,
            "period": 1030,
            "q": 1.102,
            "Q": 2.9,
            "NEO": "Y",
            "PHA": "N",
            "aN": 358.41
        },
        {
            "title": "  4957 Brucemurray (1990 XJ)",
            "a": 1.565,
            "i": 35.01,
            "e": 0.2189,
            "peri": 97.48,
            "M": 150.48,
            "period": 715,
            "q": 1.223,
            "Q": 1.91,
            "NEO": "Y",
            "PHA": "N",
            "aN": 254.88
        },
        {
            "title": "  5011 Ptah (6743 P-L)",
            "a": 1.636,
            "i": 7.41,
            "e": 0.5001,
            "peri": 105.94,
            "M": 173.66,
            "period": 764,
            "q": 0.818,
            "Q": 2.45,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 10.63
        },
        {
            "title": "  5131 (1990 BG)",
            "a": 1.486,
            "i": 36.44,
            "e": 0.5692,
            "peri": 135.87,
            "M": 358.09,
            "period": 662,
            "q": 0.64,
            "Q": 2.33,
            "NEO": "Y",
            "PHA": "N",
            "aN": 110.34
        },
        {
            "title": "  5143 Heracles (1991 VL)",
            "a": 1.835,
            "i": 8.98,
            "e": 0.771,
            "peri": 228.22,
            "M": 45.49,
            "period": 908,
            "q": 0.42,
            "Q": 3.25,
            "NEO": "Y",
            "PHA": "N",
            "aN": 309.09
        },
        {
            "title": "  5189 (1990 UQ)",
            "a": 1.552,
            "i": 3.58,
            "e": 0.4783,
            "peri": 159.95,
            "M": 257.64,
            "period": 706,
            "q": 0.809,
            "Q": 2.29,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 135.05
        },
        {
            "title": "  5324 Lyapunov (1987 SL)",
            "a": 2.982,
            "i": 19.62,
            "e": 0.6052,
            "peri": 321.13,
            "M": 101.93,
            "period": 1880,
            "q": 1.177,
            "Q": 4.79,
            "NEO": "Y",
            "PHA": "N",
            "aN": 352.16
        },
        {
            "title": "  5332 Davidaguilar (1990 DA)",
            "a": 2.163,
            "i": 25.52,
            "e": 0.4557,
            "peri": 306.07,
            "M": 339.58,
            "period": 1160,
            "q": 1.177,
            "Q": 3.15,
            "NEO": "Y",
            "PHA": "N",
            "aN": 142.77
        },
        {
            "title": "  5370 Taranis (1986 RA)",
            "a": 3.319,
            "i": 19.17,
            "e": 0.637,
            "peri": 161.31,
            "M": 90.75,
            "period": 2210,
            "q": 1.205,
            "Q": 5.43,
            "NEO": "Y",
            "PHA": "N",
            "aN": 177.79
        },
        {
            "title": "  5381 Sekhmet (1991 JY)",
            "a": 0.9475,
            "i": 48.97,
            "e": 0.2964,
            "peri": 37.42,
            "M": 199.13,
            "period": 337,
            "q": 0.667,
            "Q": 1.23,
            "NEO": "Y",
            "PHA": "N",
            "aN": 58.53
        },
        {
            "title": "  5496 (1973 NA)",
            "a": 2.435,
            "i": 68,
            "e": 0.635,
            "peri": 117.98,
            "M": 195.45,
            "period": 1390,
            "q": 0.889,
            "Q": 3.98,
            "NEO": "Y",
            "PHA": "N",
            "aN": 101.04
        },
        {
            "title": "  5587 (1990 SB)",
            "a": 2.4,
            "i": 18.07,
            "e": 0.5441,
            "peri": 86.96,
            "M": 103.89,
            "period": 1360,
            "q": 1.094,
            "Q": 3.71,
            "NEO": "Y",
            "PHA": "N",
            "aN": 189.85
        },
        {
            "title": "  5590 (1990 VA)",
            "a": 0.9864,
            "i": 14.18,
            "e": 0.2802,
            "peri": 34.47,
            "M": 25.89,
            "period": 358,
            "q": 0.71,
            "Q": 1.26,
            "NEO": "Y",
            "PHA": "N",
            "aN": 216.26
        },
        {
            "title": "  5604 (1992 FE)",
            "a": 0.9286,
            "i": 4.71,
            "e": 0.4061,
            "peri": 82.68,
            "M": 269.92,
            "period": 327,
            "q": 0.552,
            "Q": 1.31,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 311.89
        },
        {
            "title": "  5620 Jasonwheeler (1990 OA)",
            "a": 2.159,
            "i": 7.87,
            "e": 0.4228,
            "peri": 153.76,
            "M": 292.11,
            "period": 1160,
            "q": 1.246,
            "Q": 3.07,
            "NEO": "Y",
            "PHA": "N",
            "aN": 128.65
        },
        {
            "title": "  5626 Melissabrucker (1991 FE)",
            "a": 2.195,
            "i": 3.85,
            "e": 0.4547,
            "peri": 231.87,
            "M": 200.05,
            "period": 1190,
            "q": 1.197,
            "Q": 3.19,
            "NEO": "Y",
            "PHA": "N",
            "aN": 173.1
        },
        {
            "title": "  5645 (1990 SP)",
            "a": 1.355,
            "i": 13.51,
            "e": 0.3873,
            "peri": 48.27,
            "M": 164.51,
            "period": 576,
            "q": 0.83,
            "Q": 1.88,
            "NEO": "Y",
            "PHA": "N",
            "aN": 45.71
        },
        {
            "title": "  5646 (1990 TR)",
            "a": 2.144,
            "i": 7.91,
            "e": 0.4357,
            "peri": 335.77,
            "M": 314.96,
            "period": 1150,
            "q": 1.21,
            "Q": 3.08,
            "NEO": "Y",
            "PHA": "N",
            "aN": 14.1
        },
        {
            "title": "  5653 Camarillo (1992 WD5)",
            "a": 1.794,
            "i": 6.87,
            "e": 0.3042,
            "peri": 122.62,
            "M": 63.97,
            "period": 878,
            "q": 1.248,
            "Q": 2.34,
            "NEO": "Y",
            "PHA": "N",
            "aN": 9.89
        },
        {
            "title": "  5660 (1974 MA)",
            "a": 1.785,
            "i": 38.14,
            "e": 0.7621,
            "peri": 127.04,
            "M": 358.08,
            "period": 871,
            "q": 0.425,
            "Q": 3.15,
            "NEO": "Y",
            "PHA": "N",
            "aN": 302.12
        },
        {
            "title": "  5693 (1993 EA)",
            "a": 1.271,
            "i": 5.06,
            "e": 0.5851,
            "peri": 258.98,
            "M": 203.14,
            "period": 523,
            "q": 0.527,
            "Q": 2.01,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 96.98
        },
        {
            "title": "  5731 Zeus (1988 VP4)",
            "a": 2.266,
            "i": 11.2,
            "e": 0.6521,
            "peri": 218.43,
            "M": 166.28,
            "period": 1250,
            "q": 0.788,
            "Q": 3.74,
            "NEO": "Y",
            "PHA": "N",
            "aN": 280.59
        },
        {
            "title": "  5751 Zao (1992 AC)",
            "a": 2.101,
            "i": 16.07,
            "e": 0.4254,
            "peri": 25.46,
            "M": 254.35,
            "period": 1110,
            "q": 1.207,
            "Q": 3,
            "NEO": "Y",
            "PHA": "N",
            "aN": 121.63
        },
        {
            "title": "  5786 Talos (1991 RC)",
            "a": 1.081,
            "i": 23.22,
            "e": 0.8268,
            "peri": 8.39,
            "M": 277.56,
            "period": 411,
            "q": 0.187,
            "Q": 1.98,
            "NEO": "Y",
            "PHA": "N",
            "aN": 161.28
        },
        {
            "title": "  5797 Bivoj (1980 AA)",
            "a": 1.894,
            "i": 4.19,
            "e": 0.4443,
            "peri": 168.64,
            "M": 69.36,
            "period": 952,
            "q": 1.052,
            "Q": 2.74,
            "NEO": "Y",
            "PHA": "N",
            "aN": 298.92
        },
        {
            "title": "  5828 (1991 AM)",
            "a": 1.698,
            "i": 30.12,
            "e": 0.6949,
            "peri": 152.77,
            "M": 57.64,
            "period": 808,
            "q": 0.518,
            "Q": 2.88,
            "NEO": "Y",
            "PHA": "N",
            "aN": 125.42
        },
        {
            "title": "  5836 (1993 MF)",
            "a": 2.441,
            "i": 7.94,
            "e": 0.5365,
            "peri": 78.09,
            "M": 59.58,
            "period": 1390,
            "q": 1.131,
            "Q": 3.75,
            "NEO": "Y",
            "PHA": "N",
            "aN": 238.71
        },
        {
            "title": "  5863 Tara (1983 RB)",
            "a": 2.222,
            "i": 19.49,
            "e": 0.5065,
            "peri": 115.62,
            "M": 166.87,
            "period": 1210,
            "q": 1.097,
            "Q": 3.35,
            "NEO": "Y",
            "PHA": "N",
            "aN": 168.76
        },
        {
            "title": "  5869 Tanith (1988 VN4)",
            "a": 1.812,
            "i": 17.93,
            "e": 0.3213,
            "peri": 230.86,
            "M": 232.38,
            "period": 891,
            "q": 1.23,
            "Q": 2.39,
            "NEO": "Y",
            "PHA": "N",
            "aN": 227.85
        },
        {
            "title": "  5879 Almeria (1992 CH1)",
            "a": 1.625,
            "i": 21.57,
            "e": 0.2892,
            "peri": 355.78,
            "M": 283.14,
            "period": 756,
            "q": 1.155,
            "Q": 2.09,
            "NEO": "Y",
            "PHA": "N",
            "aN": 145.83
        },
        {
            "title": "  6037 (1988 EG)",
            "a": 1.272,
            "i": 3.51,
            "e": 0.4997,
            "peri": 242.32,
            "M": 249.72,
            "period": 524,
            "q": 0.636,
            "Q": 1.91,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 182.18
        },
        {
            "title": "  6047 (1991 TB1)",
            "a": 1.455,
            "i": 23.47,
            "e": 0.3521,
            "peri": 103.82,
            "M": 242.4,
            "period": 641,
            "q": 0.942,
            "Q": 1.97,
            "NEO": "Y",
            "PHA": "N",
            "aN": 6.07
        },
        {
            "title": "  6050 Miwablock (1992 AE)",
            "a": 2.202,
            "i": 6.41,
            "e": 0.4372,
            "peri": 285.05,
            "M": 33.19,
            "period": 1190,
            "q": 1.239,
            "Q": 3.17,
            "NEO": "Y",
            "PHA": "N",
            "aN": 88.15
        },
        {
            "title": "  6053 (1993 BW3)",
            "a": 2.147,
            "i": 21.58,
            "e": 0.5287,
            "peri": 74.93,
            "M": 82.05,
            "period": 1150,
            "q": 1.012,
            "Q": 3.28,
            "NEO": "Y",
            "PHA": "N",
            "aN": 318.23
        },
        {
            "title": "  6063 Jason (1984 KB)",
            "a": 2.22,
            "i": 4.96,
            "e": 0.7622,
            "peri": 337.61,
            "M": 99.9,
            "period": 1210,
            "q": 0.528,
            "Q": 3.91,
            "NEO": "Y",
            "PHA": "N",
            "aN": 169.03
        },
        {
            "title": "  6178 (1986 DA)",
            "a": 2.815,
            "i": 4.31,
            "e": 0.5845,
            "peri": 127.48,
            "M": 54.83,
            "period": 1720,
            "q": 1.169,
            "Q": 4.46,
            "NEO": "Y",
            "PHA": "N",
            "aN": 64.49
        },
        {
            "title": "  6239 Minos (1989 QF)",
            "a": 1.151,
            "i": 3.94,
            "e": 0.4126,
            "peri": 239.77,
            "M": 224.5,
            "period": 451,
            "q": 0.676,
            "Q": 1.63,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 344.53
        },
        {
            "title": "  6455 (1992 HE)",
            "a": 2.24,
            "i": 37.34,
            "e": 0.5728,
            "peri": 262.75,
            "M": 230.08,
            "period": 1220,
            "q": 0.957,
            "Q": 3.52,
            "NEO": "Y",
            "PHA": "N",
            "aN": 26.89
        },
        {
            "title": "  6456 Golombek (1992 OM)",
            "a": 2.193,
            "i": 8.22,
            "e": 0.409,
            "peri": 347.1,
            "M": 335.09,
            "period": 1190,
            "q": 1.296,
            "Q": 3.09,
            "NEO": "Y",
            "PHA": "N",
            "aN": 313.57
        },
        {
            "title": "  6489 Golevka (1991 JX)",
            "a": 2.484,
            "i": 2.27,
            "e": 0.6151,
            "peri": 68.66,
            "M": 151.88,
            "period": 1430,
            "q": 0.956,
            "Q": 4.01,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 209.42
        },
        {
            "title": "  6491 (1991 OA)",
            "a": 2.506,
            "i": 6,
            "e": 0.5917,
            "peri": 324.73,
            "M": 142.22,
            "period": 1450,
            "q": 1.023,
            "Q": 3.99,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 301
        },
        {
            "title": "  6569 Ondaatje (1993 MO)",
            "a": 1.626,
            "i": 22.64,
            "e": 0.2209,
            "peri": 167.3,
            "M": 29.09,
            "period": 757,
            "q": 1.267,
            "Q": 1.99,
            "NEO": "Y",
            "PHA": "N",
            "aN": 111.46
        },
        {
            "title": "  6611 (1993 VW)",
            "a": 1.696,
            "i": 8.7,
            "e": 0.4846,
            "peri": 281.59,
            "M": 315.03,
            "period": 807,
            "q": 0.874,
            "Q": 2.52,
            "NEO": "Y",
            "PHA": "N",
            "aN": 230.77
        },
        {
            "title": "  7025 (1993 QA)",
            "a": 1.476,
            "i": 12.61,
            "e": 0.315,
            "peri": 323.45,
            "M": 14.75,
            "period": 655,
            "q": 1.011,
            "Q": 1.94,
            "NEO": "Y",
            "PHA": "N",
            "aN": 146.59
        },
        {
            "title": "  7088 Ishtar (1992 AA)",
            "a": 1.981,
            "i": 8.3,
            "e": 0.3903,
            "peri": 354.78,
            "M": 271.76,
            "period": 1020,
            "q": 1.208,
            "Q": 2.75,
            "NEO": "Y",
            "PHA": "N",
            "aN": 102.61
        },
        {
            "title": "  7092 Cadmus (1992 LC)",
            "a": 2.545,
            "i": 17.79,
            "e": 0.6935,
            "peri": 94.77,
            "M": 30.55,
            "period": 1480,
            "q": 0.78,
            "Q": 4.31,
            "NEO": "Y",
            "PHA": "N",
            "aN": 56.72
        },
        {
            "title": "  7236 (1987 PA)",
            "a": 2.727,
            "i": 16.37,
            "e": 0.5598,
            "peri": 338.24,
            "M": 106.9,
            "period": 1640,
            "q": 1.2,
            "Q": 4.25,
            "NEO": "Y",
            "PHA": "N",
            "aN": 308.24
        },
        {
            "title": "  7335 (1989 JA)",
            "a": 1.772,
            "i": 15.17,
            "e": 0.4846,
            "peri": 232.27,
            "M": 349.17,
            "period": 862,
            "q": 0.913,
            "Q": 2.63,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 61.28
        },
        {
            "title": "  7336 Saunders (1989 RS1)",
            "a": 2.306,
            "i": 7.2,
            "e": 0.4815,
            "peri": 181.56,
            "M": 5.75,
            "period": 1280,
            "q": 1.196,
            "Q": 3.42,
            "NEO": "Y",
            "PHA": "N",
            "aN": 174.46
        },
        {
            "title": "  7341 (1991 VK)",
            "a": 1.841,
            "i": 5.41,
            "e": 0.5061,
            "peri": 173.48,
            "M": 37.89,
            "period": 913,
            "q": 0.909,
            "Q": 2.77,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 294.73
        },
        {
            "title": "  7350 (1993 VA)",
            "a": 1.356,
            "i": 7.26,
            "e": 0.3911,
            "peri": 336.7,
            "M": 183.75,
            "period": 577,
            "q": 0.826,
            "Q": 1.89,
            "NEO": "Y",
            "PHA": "N",
            "aN": 133.05
        },
        {
            "title": "  7358 Oze (1995 YA3)",
            "a": 2.199,
            "i": 4.66,
            "e": 0.502,
            "peri": 92.31,
            "M": 351.77,
            "period": 1190,
            "q": 1.095,
            "Q": 3.3,
            "NEO": "Y",
            "PHA": "N",
            "aN": 265.42
        },
        {
            "title": "  7474 (1992 TC)",
            "a": 1.565,
            "i": 7.09,
            "e": 0.2923,
            "peri": 275.65,
            "M": 129.54,
            "period": 715,
            "q": 1.108,
            "Q": 2.02,
            "NEO": "Y",
            "PHA": "N",
            "aN": 88.6
        },
        {
            "title": "  7480 Norwan (1994 PC)",
            "a": 1.568,
            "i": 9.45,
            "e": 0.3171,
            "peri": 256.87,
            "M": 98.18,
            "period": 717,
            "q": 1.071,
            "Q": 2.06,
            "NEO": "Y",
            "PHA": "N",
            "aN": 124.36
        },
        {
            "title": "  7482 (1994 PC1)",
            "a": 1.349,
            "i": 33.47,
            "e": 0.3294,
            "peri": 47.49,
            "M": 246.56,
            "period": 572,
            "q": 0.904,
            "Q": 1.79,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 117.85
        },
        {
            "title": "  7753 (1988 XB)",
            "a": 1.467,
            "i": 3.12,
            "e": 0.4817,
            "peri": 280.08,
            "M": 95.85,
            "period": 649,
            "q": 0.761,
            "Q": 2.17,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 73.39
        },
        {
            "title": "  7822 (1991 CS)",
            "a": 1.123,
            "i": 37.12,
            "e": 0.1646,
            "peri": 249.45,
            "M": 182.35,
            "period": 435,
            "q": 0.938,
            "Q": 1.31,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 156.84
        },
        {
            "title": "  7839 (1994 ND)",
            "a": 2.165,
            "i": 27.12,
            "e": 0.5187,
            "peri": 228.32,
            "M": 167.97,
            "period": 1160,
            "q": 1.042,
            "Q": 3.29,
            "NEO": "Y",
            "PHA": "N",
            "aN": 102.51
        },
        {
            "title": "  7888 (1993 UC)",
            "a": 2.438,
            "i": 26.07,
            "e": 0.6631,
            "peri": 323.01,
            "M": 24.14,
            "period": 1390,
            "q": 0.821,
            "Q": 4.05,
            "NEO": "Y",
            "PHA": "N",
            "aN": 165.89
        },
        {
            "title": "  7889 (1994 LX)",
            "a": 1.262,
            "i": 36.91,
            "e": 0.3463,
            "peri": 349.18,
            "M": 337.1,
            "period": 518,
            "q": 0.825,
            "Q": 1.7,
            "NEO": "Y",
            "PHA": "N",
            "aN": 111.26
        },
        {
            "title": "  7977 (1977 QQ5)",
            "a": 2.226,
            "i": 25.17,
            "e": 0.4664,
            "peri": 248.11,
            "M": 53.3,
            "period": 1210,
            "q": 1.188,
            "Q": 3.26,
            "NEO": "Y",
            "PHA": "N",
            "aN": 134.13
        },
        {
            "title": "  8013 Gordonmoore (1990 KA)",
            "a": 2.202,
            "i": 7.59,
            "e": 0.4316,
            "peri": 147.2,
            "M": 190.8,
            "period": 1190,
            "q": 1.252,
            "Q": 3.15,
            "NEO": "Y",
            "PHA": "N",
            "aN": 105.36
        },
        {
            "title": "  8014 (1990 MF)",
            "a": 1.747,
            "i": 1.87,
            "e": 0.456,
            "peri": 114.73,
            "M": 291.48,
            "period": 844,
            "q": 0.951,
            "Q": 2.54,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 209.84
        },
        {
            "title": "  8034 Akka (1992 LR)",
            "a": 1.83,
            "i": 2.02,
            "e": 0.409,
            "peri": 68.19,
            "M": 5.05,
            "period": 904,
            "q": 1.082,
            "Q": 2.58,
            "NEO": "Y",
            "PHA": "N",
            "aN": 232.82
        },
        {
            "title": "  8035 (1992 TB)",
            "a": 1.342,
            "i": 28.3,
            "e": 0.4624,
            "peri": 6.12,
            "M": 13.7,
            "period": 568,
            "q": 0.722,
            "Q": 1.96,
            "NEO": "Y",
            "PHA": "N",
            "aN": 185.61
        },
        {
            "title": "  8037 (1993 HO1)",
            "a": 1.987,
            "i": 5.91,
            "e": 0.4174,
            "peri": 105.73,
            "M": 131.38,
            "period": 1020,
            "q": 1.157,
            "Q": 2.82,
            "NEO": "Y",
            "PHA": "N",
            "aN": 22.38
        },
        {
            "title": "  8176 (1991 WA)",
            "a": 1.575,
            "i": 39.59,
            "e": 0.6432,
            "peri": 241.88,
            "M": 260.84,
            "period": 722,
            "q": 0.562,
            "Q": 2.59,
            "NEO": "Y",
            "PHA": "N",
            "aN": 66.51
        },
        {
            "title": "  8201 (1994 AH2)",
            "a": 2.539,
            "i": 9.54,
            "e": 0.7061,
            "peri": 25.13,
            "M": 199.52,
            "period": 1480,
            "q": 0.746,
            "Q": 4.33,
            "NEO": "Y",
            "PHA": "N",
            "aN": 164.09
        },
        {
            "title": "  8507 (1991 CB1)",
            "a": 1.687,
            "i": 14.58,
            "e": 0.5944,
            "peri": 345.77,
            "M": 9.42,
            "period": 800,
            "q": 0.684,
            "Q": 2.69,
            "NEO": "Y",
            "PHA": "N",
            "aN": 317.41
        },
        {
            "title": "  8566 (1996 EN)",
            "a": 1.506,
            "i": 37.97,
            "e": 0.4302,
            "peri": 125.13,
            "M": 90.11,
            "period": 675,
            "q": 0.858,
            "Q": 2.15,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 164.12
        },
        {
            "title": "  8567 (1996 HW1)",
            "a": 2.045,
            "i": 8.45,
            "e": 0.4493,
            "peri": 177.3,
            "M": 179.54,
            "period": 1070,
            "q": 1.126,
            "Q": 2.96,
            "NEO": "Y",
            "PHA": "N",
            "aN": 177.1
        },
        {
            "title": "  8709 Kadlu (1994 JF1)",
            "a": 2.526,
            "i": 3.53,
            "e": 0.4925,
            "peri": 153.85,
            "M": 182.31,
            "period": 1470,
            "q": 1.282,
            "Q": 3.77,
            "NEO": "Y",
            "PHA": "N",
            "aN": 118.97
        },
        {
            "title": "  9058 (1992 JB)",
            "a": 1.557,
            "i": 16.09,
            "e": 0.3596,
            "peri": 307.06,
            "M": 284.9,
            "period": 709,
            "q": 0.997,
            "Q": 2.12,
            "NEO": "Y",
            "PHA": "N",
            "aN": 218.3
        },
        {
            "title": "  9162 Kwiila (1987 OA)",
            "a": 1.497,
            "i": 9.01,
            "e": 0.5956,
            "peri": 235.83,
            "M": 77.31,
            "period": 669,
            "q": 0.605,
            "Q": 2.39,
            "NEO": "Y",
            "PHA": "N",
            "aN": 179.99
        },
        {
            "title": "  9172 Abhramu (1989 OB)",
            "a": 2.709,
            "i": 7.84,
            "e": 0.5527,
            "peri": 74.17,
            "M": 318.4,
            "period": 1630,
            "q": 1.212,
            "Q": 4.21,
            "NEO": "Y",
            "PHA": "N",
            "aN": 287.57
        },
        {
            "title": "  9202 (1993 PB)",
            "a": 1.424,
            "i": 40.8,
            "e": 0.6078,
            "peri": 212.36,
            "M": 225.05,
            "period": 621,
            "q": 0.558,
            "Q": 2.29,
            "NEO": "Y",
            "PHA": "N",
            "aN": 315.89
        },
        {
            "title": "  9400 (1994 TW1)",
            "a": 2.587,
            "i": 36,
            "e": 0.5809,
            "peri": 62.14,
            "M": 51.21,
            "period": 1520,
            "q": 1.084,
            "Q": 4.09,
            "NEO": "Y",
            "PHA": "N",
            "aN": 3.36
        },
        {
            "title": "  9856 (1991 EE)",
            "a": 2.242,
            "i": 9.83,
            "e": 0.6258,
            "peri": 116.18,
            "M": 314.61,
            "period": 1230,
            "q": 0.839,
            "Q": 3.65,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 168.11
        },
        {
            "title": "  9950 ESA (1990 VB)",
            "a": 2.438,
            "i": 14.6,
            "e": 0.5327,
            "peri": 103.6,
            "M": 331.06,
            "period": 1390,
            "q": 1.14,
            "Q": 3.74,
            "NEO": "Y",
            "PHA": "N",
            "aN": 253.45
        },
        {
            "title": " 10115 (1992 SK)",
            "a": 1.249,
            "i": 15.32,
            "e": 0.325,
            "peri": 233.69,
            "M": 84.54,
            "period": 510,
            "q": 0.843,
            "Q": 1.65,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 8.89
        },
        {
            "title": " 10145 (1994 CK1)",
            "a": 1.901,
            "i": 4.55,
            "e": 0.6326,
            "peri": 27.45,
            "M": 348.39,
            "period": 957,
            "q": 0.698,
            "Q": 3.1,
            "NEO": "Y",
            "PHA": "N",
            "aN": 328.38
        },
        {
            "title": " 10150 (1994 PN)",
            "a": 2.375,
            "i": 45.95,
            "e": 0.544,
            "peri": 234.04,
            "M": 67.7,
            "period": 1340,
            "q": 1.083,
            "Q": 3.67,
            "NEO": "Y",
            "PHA": "N",
            "aN": 112.97
        },
        {
            "title": " 10165 (1995 BL2)",
            "a": 1.235,
            "i": 23.9,
            "e": 0.5037,
            "peri": 348.46,
            "M": 91.71,
            "period": 501,
            "q": 0.613,
            "Q": 1.86,
            "NEO": "Y",
            "PHA": "N",
            "aN": 312.42
        },
        {
            "title": " 10302 (1989 ML)",
            "a": 1.273,
            "i": 4.38,
            "e": 0.137,
            "peri": 183.65,
            "M": 206.92,
            "period": 524,
            "q": 1.098,
            "Q": 1.45,
            "NEO": "Y",
            "PHA": "N",
            "aN": 104.27
        },
        {
            "title": " 10563 Izhdubar (1993 WD)",
            "a": 1.007,
            "i": 63.47,
            "e": 0.2662,
            "peri": 132.2,
            "M": 106.82,
            "period": 369,
            "q": 0.739,
            "Q": 1.27,
            "NEO": "Y",
            "PHA": "N",
            "aN": 56.56
        },
        {
            "title": " 10636 (1998 QK56)",
            "a": 1.884,
            "i": 13.58,
            "e": 0.5129,
            "peri": 286.31,
            "M": 359.24,
            "period": 945,
            "q": 0.918,
            "Q": 2.85,
            "NEO": "Y",
            "PHA": "N",
            "aN": 172.93
        },
        {
            "title": " 10860 (1995 LE)",
            "a": 2.578,
            "i": 4.15,
            "e": 0.574,
            "peri": 75.53,
            "M": 16.39,
            "period": 1510,
            "q": 1.098,
            "Q": 4.06,
            "NEO": "Y",
            "PHA": "N",
            "aN": 257.19
        },
        {
            "title": " 11054 (1991 FA)",
            "a": 1.979,
            "i": 3.08,
            "e": 0.4467,
            "peri": 92.34,
            "M": 74.07,
            "period": 1020,
            "q": 1.095,
            "Q": 2.86,
            "NEO": "Y",
            "PHA": "N",
            "aN": 339.05
        },
        {
            "title": " 11066 Sigurd (1992 CC1)",
            "a": 1.392,
            "i": 36.88,
            "e": 0.3754,
            "peri": 22.03,
            "M": 75.15,
            "period": 600,
            "q": 0.869,
            "Q": 1.91,
            "NEO": "Y",
            "PHA": "N",
            "aN": 349.22
        },
        {
            "title": " 11284 Belenus (1990 BA)",
            "a": 1.74,
            "i": 1.99,
            "e": 0.3373,
            "peri": 171.13,
            "M": 44.4,
            "period": 838,
            "q": 1.153,
            "Q": 2.33,
            "NEO": "Y",
            "PHA": "N",
            "aN": 311.71
        },
        {
            "title": " 11311 Peleus (1993 XN2)",
            "a": 2.117,
            "i": 25.49,
            "e": 0.5359,
            "peri": 313.45,
            "M": 26.51,
            "period": 1130,
            "q": 0.983,
            "Q": 3.25,
            "NEO": "Y",
            "PHA": "N",
            "aN": 59.32
        },
        {
            "title": " 11398 (1998 YP11)",
            "a": 1.721,
            "i": 15.02,
            "e": 0.3895,
            "peri": 74.76,
            "M": 107,
            "period": 824,
            "q": 1.05,
            "Q": 2.39,
            "NEO": "Y",
            "PHA": "N",
            "aN": 144.74
        },
        {
            "title": " 11405 (1999 CV3)",
            "a": 1.46,
            "i": 22.86,
            "e": 0.3939,
            "peri": 96.4,
            "M": 153.9,
            "period": 644,
            "q": 0.885,
            "Q": 2.03,
            "NEO": "Y",
            "PHA": "N",
            "aN": 141.25
        },
        {
            "title": " 11500 Tomaiyowit (1989 UR)",
            "a": 1.08,
            "i": 10.31,
            "e": 0.3558,
            "peri": 289.52,
            "M": 323.61,
            "period": 410,
            "q": 0.696,
            "Q": 1.46,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 234.39
        },
        {
            "title": " 11885 Summanus (1990 SS)",
            "a": 1.703,
            "i": 19.43,
            "e": 0.4744,
            "peri": 116.2,
            "M": 59.35,
            "period": 812,
            "q": 0.895,
            "Q": 2.51,
            "NEO": "Y",
            "PHA": "N",
            "aN": 359.78
        },
        {
            "title": " 12538 (1998 OH)",
            "a": 1.542,
            "i": 24.54,
            "e": 0.4058,
            "peri": 321.79,
            "M": 317.04,
            "period": 699,
            "q": 0.916,
            "Q": 2.17,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 220.69
        },
        {
            "title": " 12711 Tukmit (1991 BB)",
            "a": 1.186,
            "i": 38.49,
            "e": 0.2722,
            "peri": 322.88,
            "M": 291.28,
            "period": 472,
            "q": 0.863,
            "Q": 1.51,
            "NEO": "Y",
            "PHA": "N",
            "aN": 294.96
        },
        {
            "title": " 12923 Zephyr (1999 GK4)",
            "a": 1.963,
            "i": 5.3,
            "e": 0.4918,
            "peri": 147.13,
            "M": 51.56,
            "period": 1000,
            "q": 0.998,
            "Q": 2.93,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 168.17
        },
        {
            "title": " 13553 Masaakikoyama (1992 JE)",
            "a": 2.189,
            "i": 5.88,
            "e": 0.4637,
            "peri": 109.95,
            "M": 333.19,
            "period": 1180,
            "q": 1.174,
            "Q": 3.2,
            "NEO": "Y",
            "PHA": "N",
            "aN": 193.46
        },
        {
            "title": " 13651 (1997 BR)",
            "a": 1.335,
            "i": 17.25,
            "e": 0.3057,
            "peri": 133.86,
            "M": 262.62,
            "period": 564,
            "q": 0.927,
            "Q": 1.74,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 116.63
        },
        {
            "title": " 14402 (1991 DB)",
            "a": 1.715,
            "i": 11.41,
            "e": 0.4016,
            "peri": 51.55,
            "M": 325.5,
            "period": 820,
            "q": 1.026,
            "Q": 2.4,
            "NEO": "Y",
            "PHA": "N",
            "aN": 158.14
        },
        {
            "title": " 14827 Hypnos (1986 JK)",
            "a": 2.841,
            "i": 1.98,
            "e": 0.6649,
            "peri": 238.19,
            "M": 21.63,
            "period": 1750,
            "q": 0.952,
            "Q": 4.73,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 57.93
        },
        {
            "title": " 15745 Yuliya (1991 PM5)",
            "a": 1.72,
            "i": 14.43,
            "e": 0.2555,
            "peri": 140.66,
            "M": 284.35,
            "period": 824,
            "q": 1.28,
            "Q": 2.16,
            "NEO": "Y",
            "PHA": "N",
            "aN": 132.58
        },
        {
            "title": " 15817 Lucianotesi (1994 QC)",
            "a": 1.324,
            "i": 13.87,
            "e": 0.1182,
            "peri": 94.29,
            "M": 340.12,
            "period": 557,
            "q": 1.168,
            "Q": 1.48,
            "NEO": "Y",
            "PHA": "N",
            "aN": 162.47
        },
        {
            "title": " 16064 Davidharvey (1999 RH27)",
            "a": 2.849,
            "i": 4.54,
            "e": 0.5894,
            "peri": 104.75,
            "M": 43.97,
            "period": 1760,
            "q": 1.17,
            "Q": 4.53,
            "NEO": "Y",
            "PHA": "N",
            "aN": 335.55
        },
        {
            "title": " 16636 (1993 QP)",
            "a": 2.31,
            "i": 7.21,
            "e": 0.4677,
            "peri": 47.38,
            "M": 314.66,
            "period": 1280,
            "q": 1.23,
            "Q": 3.39,
            "NEO": "Y",
            "PHA": "N",
            "aN": 296.77
        },
        {
            "title": " 16657 (1993 UB)",
            "a": 2.277,
            "i": 24.95,
            "e": 0.4608,
            "peri": 21.3,
            "M": 356.33,
            "period": 1260,
            "q": 1.228,
            "Q": 3.33,
            "NEO": "Y",
            "PHA": "N",
            "aN": 31.19
        },
        {
            "title": " 16816 (1997 UF9)",
            "a": 1.442,
            "i": 25.92,
            "e": 0.6038,
            "peri": 158.01,
            "M": 95.46,
            "period": 633,
            "q": 0.571,
            "Q": 2.31,
            "NEO": "Y",
            "PHA": "N",
            "aN": 37.14
        },
        {
            "title": " 16834 (1997 WU22)",
            "a": 1.468,
            "i": 16,
            "e": 0.4421,
            "peri": 334.39,
            "M": 247.48,
            "period": 650,
            "q": 0.819,
            "Q": 2.12,
            "NEO": "Y",
            "PHA": "N",
            "aN": 260.76
        },
        {
            "title": " 16912 Rhiannon (1998 EP8)",
            "a": 1.751,
            "i": 24.52,
            "e": 0.2726,
            "peri": 221.25,
            "M": 284.67,
            "period": 847,
            "q": 1.274,
            "Q": 2.23,
            "NEO": "Y",
            "PHA": "N",
            "aN": 169.17
        },
        {
            "title": " 16960 (1998 QS52)",
            "a": 2.201,
            "i": 17.52,
            "e": 0.859,
            "peri": 243.25,
            "M": 308.68,
            "period": 1190,
            "q": 0.31,
            "Q": 4.09,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 260.15
        },
        {
            "title": " 17181 (1999 UM3)",
            "a": 2.37,
            "i": 10.65,
            "e": 0.674,
            "peri": 36.78,
            "M": 275.92,
            "period": 1330,
            "q": 0.773,
            "Q": 3.97,
            "NEO": "Y",
            "PHA": "N",
            "aN": 113.56
        },
        {
            "title": " 17182 (1999 VU)",
            "a": 1.387,
            "i": 9.26,
            "e": 0.5533,
            "peri": 203.23,
            "M": 25.7,
            "period": 597,
            "q": 0.62,
            "Q": 2.15,
            "NEO": "Y",
            "PHA": "N",
            "aN": 333.48
        },
        {
            "title": " 17188 (1999 WC2)",
            "a": 2.216,
            "i": 29.45,
            "e": 0.6369,
            "peri": 287.25,
            "M": 172.44,
            "period": 1200,
            "q": 0.805,
            "Q": 3.63,
            "NEO": "Y",
            "PHA": "N",
            "aN": 269.76
        },
        {
            "title": " 17274 (2000 LC16)",
            "a": 2.731,
            "i": 5.57,
            "e": 0.5539,
            "peri": 21.35,
            "M": 129.39,
            "period": 1650,
            "q": 1.219,
            "Q": 4.24,
            "NEO": "Y",
            "PHA": "N",
            "aN": 305.7
        },
        {
            "title": " 17511 (1992 QN)",
            "a": 1.19,
            "i": 9.58,
            "e": 0.3587,
            "peri": 202.44,
            "M": 10.89,
            "period": 474,
            "q": 0.763,
            "Q": 1.62,
            "NEO": "Y",
            "PHA": "N",
            "aN": 355.89
        },
        {
            "title": " 18106 Blume (2000 NX3)",
            "a": 2.443,
            "i": 4.22,
            "e": 0.512,
            "peri": 234.96,
            "M": 112.61,
            "period": 1390,
            "q": 1.192,
            "Q": 3.69,
            "NEO": "Y",
            "PHA": "N",
            "aN": 109.17
        },
        {
            "title": " 18109 (2000 NG11)",
            "a": 1.881,
            "i": 0.81,
            "e": 0.3679,
            "peri": 319.26,
            "M": 117.48,
            "period": 942,
            "q": 1.189,
            "Q": 2.57,
            "NEO": "Y",
            "PHA": "N",
            "aN": 59.54
        },
        {
            "title": " 18172 (2000 QL7)",
            "a": 2.425,
            "i": 17.83,
            "e": 0.5111,
            "peri": 100.71,
            "M": 102.38,
            "period": 1380,
            "q": 1.186,
            "Q": 3.67,
            "NEO": "Y",
            "PHA": "N",
            "aN": 338.45
        },
        {
            "title": " 18736 (1998 NU)",
            "a": 2.349,
            "i": 2.81,
            "e": 0.491,
            "peri": 222.92,
            "M": 199.67,
            "period": 1320,
            "q": 1.196,
            "Q": 3.5,
            "NEO": "Y",
            "PHA": "N",
            "aN": 297.43
        },
        {
            "title": " 18882 (1999 YN4)",
            "a": 1.685,
            "i": 36.81,
            "e": 0.232,
            "peri": 242.69,
            "M": 49.89,
            "period": 799,
            "q": 1.294,
            "Q": 2.08,
            "NEO": "Y",
            "PHA": "N",
            "aN": 291.67
        },
        {
            "title": " 19356 (1997 GH3)",
            "a": 2.512,
            "i": 3.01,
            "e": 0.5576,
            "peri": 334.13,
            "M": 354.22,
            "period": 1450,
            "q": 1.111,
            "Q": 3.91,
            "NEO": "Y",
            "PHA": "N",
            "aN": 186.48
        },
        {
            "title": " 19764 (2000 NF5)",
            "a": 2.235,
            "i": 1.33,
            "e": 0.4428,
            "peri": 9.75,
            "M": 106.69,
            "period": 1220,
            "q": 1.245,
            "Q": 3.22,
            "NEO": "Y",
            "PHA": "N",
            "aN": 281.4
        },
        {
            "title": " 20086 (1994 LW)",
            "a": 3.176,
            "i": 21.79,
            "e": 0.6253,
            "peri": 57.78,
            "M": 116.25,
            "period": 2070,
            "q": 1.19,
            "Q": 5.16,
            "NEO": "Y",
            "PHA": "N",
            "aN": 237.14
        },
        {
            "title": " 20236 (1998 BZ7)",
            "a": 2.034,
            "i": 6.51,
            "e": 0.561,
            "peri": 104.58,
            "M": 42.72,
            "period": 1060,
            "q": 0.893,
            "Q": 3.17,
            "NEO": "Y",
            "PHA": "N",
            "aN": 111.23
        },
        {
            "title": " 20255 (1998 FX2)",
            "a": 2.151,
            "i": 9.96,
            "e": 0.4922,
            "peri": 17.56,
            "M": 144.77,
            "period": 1150,
            "q": 1.092,
            "Q": 3.21,
            "NEO": "Y",
            "PHA": "N",
            "aN": 180.93
        },
        {
            "title": " 20425 (1998 VD35)",
            "a": 1.565,
            "i": 6.99,
            "e": 0.4764,
            "peri": 296.32,
            "M": 32.7,
            "period": 715,
            "q": 0.819,
            "Q": 2.31,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 227.25
        },
        {
            "title": " 20429 (1998 YN1)",
            "a": 1.556,
            "i": 6.3,
            "e": 0.4642,
            "peri": 147.72,
            "M": 42.37,
            "period": 709,
            "q": 0.834,
            "Q": 2.28,
            "NEO": "Y",
            "PHA": "N",
            "aN": 61.73
        },
        {
            "title": " 20460 Robwhiteley (1999 LO28)",
            "a": 1.877,
            "i": 33.95,
            "e": 0.4116,
            "peri": 283.75,
            "M": 343.48,
            "period": 939,
            "q": 1.104,
            "Q": 2.65,
            "NEO": "Y",
            "PHA": "N",
            "aN": 279.99
        },
        {
            "title": " 20790 (2000 SE45)",
            "a": 2.753,
            "i": 8.29,
            "e": 0.5561,
            "peri": 168.95,
            "M": 80.23,
            "period": 1670,
            "q": 1.222,
            "Q": 4.28,
            "NEO": "Y",
            "PHA": "N",
            "aN": 302.85
        },
        {
            "title": " 20826 (2000 UV13)",
            "a": 2.418,
            "i": 31.92,
            "e": 0.6362,
            "peri": 198.7,
            "M": 93.36,
            "period": 1370,
            "q": 0.88,
            "Q": 3.96,
            "NEO": "Y",
            "PHA": "N",
            "aN": 347.28
        },
        {
            "title": " 21088 Chelyabinsk (1992 BL2)",
            "a": 1.706,
            "i": 38.45,
            "e": 0.2384,
            "peri": 27.16,
            "M": 28.4,
            "period": 814,
            "q": 1.3,
            "Q": 2.11,
            "NEO": "Y",
            "PHA": "N",
            "aN": 297.83
        },
        {
            "title": " 21277 (1996 TO5)",
            "a": 2.378,
            "i": 20.95,
            "e": 0.5204,
            "peri": 250.16,
            "M": 206.86,
            "period": 1340,
            "q": 1.141,
            "Q": 3.62,
            "NEO": "Y",
            "PHA": "N",
            "aN": 167.35
        },
        {
            "title": " 21374 (1997 WS22)",
            "a": 1.269,
            "i": 23.98,
            "e": 0.1207,
            "peri": 197.28,
            "M": 89.26,
            "period": 522,
            "q": 1.116,
            "Q": 1.42,
            "NEO": "Y",
            "PHA": "N",
            "aN": 59.19
        },
        {
            "title": " 22099 (2000 EX106)",
            "a": 1.104,
            "i": 9.85,
            "e": 0.2762,
            "peri": 186.56,
            "M": 320.17,
            "period": 424,
            "q": 0.799,
            "Q": 1.41,
            "NEO": "Y",
            "PHA": "N",
            "aN": 136.43
        },
        {
            "title": " 22753 (1998 WT)",
            "a": 1.219,
            "i": 3.2,
            "e": 0.5699,
            "peri": 324.8,
            "M": 165.33,
            "period": 492,
            "q": 0.524,
            "Q": 1.91,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 307.36
        },
        {
            "title": " 22771 (1999 CU3)",
            "a": 1.576,
            "i": 11.4,
            "e": 0.5243,
            "peri": 305.83,
            "M": 256.93,
            "period": 723,
            "q": 0.75,
            "Q": 2.4,
            "NEO": "Y",
            "PHA": "N",
            "aN": 338.91
        },
        {
            "title": " 23183 (2000 OY21)",
            "a": 1.824,
            "i": 40.97,
            "e": 0.4009,
            "peri": 301.48,
            "M": 239.12,
            "period": 900,
            "q": 1.093,
            "Q": 2.56,
            "NEO": "Y",
            "PHA": "N",
            "aN": 119.63
        },
        {
            "title": " 23187 (2000 PN9)",
            "a": 1.847,
            "i": 51.33,
            "e": 0.5893,
            "peri": 293.53,
            "M": 167.5,
            "period": 917,
            "q": 0.759,
            "Q": 2.94,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 164.29
        },
        {
            "title": " 23548 (1994 EF2)",
            "a": 2.289,
            "i": 23.44,
            "e": 0.518,
            "peri": 124.29,
            "M": 313.15,
            "period": 1270,
            "q": 1.104,
            "Q": 3.47,
            "NEO": "Y",
            "PHA": "N",
            "aN": 345.85
        },
        {
            "title": " 23606 (1996 AS1)",
            "a": 1.75,
            "i": 14.36,
            "e": 0.3611,
            "peri": 357.59,
            "M": 350.36,
            "period": 846,
            "q": 1.118,
            "Q": 2.38,
            "NEO": "Y",
            "PHA": "N",
            "aN": 296.61
        },
        {
            "title": " 23714 (1998 EC3)",
            "a": 2.13,
            "i": 8.41,
            "e": 0.5162,
            "peri": 129.34,
            "M": 164.63,
            "period": 1140,
            "q": 1.031,
            "Q": 3.23,
            "NEO": "Y",
            "PHA": "N",
            "aN": 127.61
        },
        {
            "title": " 24443 (2000 OG)",
            "a": 2.311,
            "i": 25.74,
            "e": 0.8224,
            "peri": 231.22,
            "M": 307.38,
            "period": 1280,
            "q": 0.41,
            "Q": 4.21,
            "NEO": "Y",
            "PHA": "N",
            "aN": 178.08
        },
        {
            "title": " 24445 (2000 PM8)",
            "a": 2.211,
            "i": 23.78,
            "e": 0.5459,
            "peri": 219.08,
            "M": 119.45,
            "period": 1200,
            "q": 1.004,
            "Q": 3.42,
            "NEO": "Y",
            "PHA": "N",
            "aN": 203.16
        },
        {
            "title": " 24475 (2000 VN2)",
            "a": 1.975,
            "i": 14.63,
            "e": 0.4415,
            "peri": 32.69,
            "M": 213.81,
            "period": 1010,
            "q": 1.103,
            "Q": 2.85,
            "NEO": "Y",
            "PHA": "N",
            "aN": 76.4
        },
        {
            "title": " 24761 Ahau (1993 BW2)",
            "a": 1.335,
            "i": 21.92,
            "e": 0.3058,
            "peri": 287.55,
            "M": 245.98,
            "period": 563,
            "q": 0.927,
            "Q": 1.74,
            "NEO": "Y",
            "PHA": "N",
            "aN": 121.04
        },
        {
            "title": " 25143 Itokawa (1998 SF36)",
            "a": 1.324,
            "i": 1.62,
            "e": 0.2803,
            "peri": 162.82,
            "M": 142.57,
            "period": 557,
            "q": 0.953,
            "Q": 1.7,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 69.08
        },
        {
            "title": " 25330 (1999 KV4)",
            "a": 1.541,
            "i": 14.33,
            "e": 0.3708,
            "peri": 86.1,
            "M": 129.11,
            "period": 699,
            "q": 0.969,
            "Q": 2.11,
            "NEO": "Y",
            "PHA": "N",
            "aN": 50.52
        },
        {
            "title": " 25916 (2001 CP44)",
            "a": 2.559,
            "i": 15.76,
            "e": 0.4991,
            "peri": 199.69,
            "M": 186.18,
            "period": 1490,
            "q": 1.282,
            "Q": 3.84,
            "NEO": "Y",
            "PHA": "N",
            "aN": 94.64
        },
        {
            "title": " 26166 (1995 QN3)",
            "a": 3.302,
            "i": 14.79,
            "e": 0.6445,
            "peri": 62.87,
            "M": 331.54,
            "period": 2190,
            "q": 1.174,
            "Q": 5.43,
            "NEO": "Y",
            "PHA": "N",
            "aN": 185.7
        },
        {
            "title": " 26310 (1998 TX6)",
            "a": 2.139,
            "i": 5.38,
            "e": 0.469,
            "peri": 98.89,
            "M": 143.89,
            "period": 1140,
            "q": 1.136,
            "Q": 3.14,
            "NEO": "Y",
            "PHA": "N",
            "aN": 210.82
        },
        {
            "title": " 26379 (1999 HZ1)",
            "a": 1.606,
            "i": 8.68,
            "e": 0.5763,
            "peri": 200.6,
            "M": 239.86,
            "period": 743,
            "q": 0.681,
            "Q": 2.53,
            "NEO": "Y",
            "PHA": "N",
            "aN": 252.1
        },
        {
            "title": " 26663 (2000 XK47)",
            "a": 1.546,
            "i": 13.53,
            "e": 0.4717,
            "peri": 231.23,
            "M": 108.78,
            "period": 702,
            "q": 0.817,
            "Q": 2.28,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 303.59
        },
        {
            "title": " 26760 (2001 KP41)",
            "a": 2.853,
            "i": 11.02,
            "e": 0.5571,
            "peri": 155.16,
            "M": 289.19,
            "period": 1760,
            "q": 1.264,
            "Q": 4.44,
            "NEO": "Y",
            "PHA": "N",
            "aN": 146.26
        },
        {
            "title": " 26817 (1987 QB)",
            "a": 2.804,
            "i": 3.5,
            "e": 0.5938,
            "peri": 156.55,
            "M": 336.97,
            "period": 1720,
            "q": 1.139,
            "Q": 4.47,
            "NEO": "Y",
            "PHA": "N",
            "aN": 153.19
        },
        {
            "title": " 27002 (1998 DV9)",
            "a": 1.744,
            "i": 8.7,
            "e": 0.4333,
            "peri": 0.82,
            "M": 203.62,
            "period": 841,
            "q": 0.988,
            "Q": 2.5,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 130.34
        },
        {
            "title": " 27031 (1998 RO4)",
            "a": 2.139,
            "i": 5.35,
            "e": 0.4256,
            "peri": 111.88,
            "M": 142.56,
            "period": 1140,
            "q": 1.229,
            "Q": 3.05,
            "NEO": "Y",
            "PHA": "N",
            "aN": 191.8
        },
        {
            "title": " 27346 (2000 DN8)",
            "a": 1.875,
            "i": 36.95,
            "e": 0.399,
            "peri": 269.29,
            "M": 295.12,
            "period": 938,
            "q": 1.127,
            "Q": 2.62,
            "NEO": "Y",
            "PHA": "N",
            "aN": 135.19
        },
        {
            "title": " 29075 (1950 DA)",
            "a": 1.699,
            "i": 12.16,
            "e": 0.5077,
            "peri": 224.76,
            "M": 223.31,
            "period": 809,
            "q": 0.836,
            "Q": 2.56,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 356.59
        },
        {
            "title": " 30825 (1990 TG1)",
            "a": 2.436,
            "i": 8.74,
            "e": 0.6812,
            "peri": 33.67,
            "M": 40.46,
            "period": 1390,
            "q": 0.777,
            "Q": 4.1,
            "NEO": "Y",
            "PHA": "N",
            "aN": 205.02
        },
        {
            "title": " 30997 (1995 UO5)",
            "a": 1.56,
            "i": 36.26,
            "e": 0.6432,
            "peri": 151.17,
            "M": 206.27,
            "period": 712,
            "q": 0.556,
            "Q": 2.56,
            "NEO": "Y",
            "PHA": "N",
            "aN": 38.62
        },
        {
            "title": " 31210 (1998 BX7)",
            "a": 2.606,
            "i": 8.96,
            "e": 0.5022,
            "peri": 271.42,
            "M": 157.48,
            "period": 1540,
            "q": 1.297,
            "Q": 3.92,
            "NEO": "Y",
            "PHA": "N",
            "aN": 144.89
        },
        {
            "title": " 31221 (1998 BP26)",
            "a": 1.723,
            "i": 20.22,
            "e": 0.257,
            "peri": 186.76,
            "M": 284.97,
            "period": 826,
            "q": 1.28,
            "Q": 2.17,
            "NEO": "Y",
            "PHA": "N",
            "aN": 331.02
        },
        {
            "title": " 31345 (1998 PG)",
            "a": 2.016,
            "i": 6.5,
            "e": 0.3915,
            "peri": 156.23,
            "M": 30.83,
            "period": 1050,
            "q": 1.226,
            "Q": 2.8,
            "NEO": "Y",
            "PHA": "N",
            "aN": 222.69
        },
        {
            "title": " 31346 (1998 PB1)",
            "a": 2.03,
            "i": 5.96,
            "e": 0.4297,
            "peri": 350.49,
            "M": 28.4,
            "period": 1060,
            "q": 1.158,
            "Q": 2.9,
            "NEO": "Y",
            "PHA": "N",
            "aN": 299.71
        },
        {
            "title": " 31662 (1999 HP11)",
            "a": 1.597,
            "i": 18.82,
            "e": 0.5479,
            "peri": 312.03,
            "M": 158.87,
            "period": 737,
            "q": 0.722,
            "Q": 2.47,
            "NEO": "Y",
            "PHA": "N",
            "aN": 13.94
        },
        {
            "title": " 31669 (1999 JT6)",
            "a": 2.137,
            "i": 9.54,
            "e": 0.5776,
            "peri": 39.1,
            "M": 97.39,
            "period": 1140,
            "q": 0.903,
            "Q": 3.37,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 78.77
        },
        {
            "title": " 32906 (1994 RH)",
            "a": 2.247,
            "i": 18.94,
            "e": 0.4404,
            "peri": 92.38,
            "M": 302.67,
            "period": 1230,
            "q": 1.258,
            "Q": 3.24,
            "NEO": "Y",
            "PHA": "N",
            "aN": 331.14
        },
        {
            "title": " 33342 (1998 WT24)",
            "a": 0.7187,
            "i": 7.37,
            "e": 0.4177,
            "peri": 167.52,
            "M": 27.5,
            "period": 223,
            "q": 0.419,
            "Q": 1.02,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 81.66
        },
        {
            "title": " 34613 (2000 UR13)",
            "a": 2.07,
            "i": 6.17,
            "e": 0.3869,
            "peri": 286.22,
            "M": 140.35,
            "period": 1090,
            "q": 1.269,
            "Q": 2.87,
            "NEO": "Y",
            "PHA": "N",
            "aN": 315.25
        },
        {
            "title": " 35107 (1991 VH)",
            "a": 1.137,
            "i": 13.91,
            "e": 0.1442,
            "peri": 206.96,
            "M": 100.55,
            "period": 443,
            "q": 0.973,
            "Q": 1.3,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 139.34
        },
        {
            "title": " 35396 (1997 XF11)",
            "a": 1.442,
            "i": 4.1,
            "e": 0.4837,
            "peri": 103.04,
            "M": 272.13,
            "period": 633,
            "q": 0.745,
            "Q": 2.14,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 213.65
        },
        {
            "title": " 35432 (1998 BG9)",
            "a": 2.501,
            "i": 13.15,
            "e": 0.5456,
            "peri": 1.6,
            "M": 259.41,
            "period": 1440,
            "q": 1.136,
            "Q": 3.86,
            "NEO": "Y",
            "PHA": "N",
            "aN": 115.32
        },
        {
            "title": " 35670 (1998 SU27)",
            "a": 2.122,
            "i": 7.14,
            "e": 0.5964,
            "peri": 169.85,
            "M": 130.45,
            "period": 1130,
            "q": 0.857,
            "Q": 3.39,
            "NEO": "Y",
            "PHA": "N",
            "aN": 271.33
        },
        {
            "title": " 36017 (1999 ND43)",
            "a": 1.523,
            "i": 5.55,
            "e": 0.3143,
            "peri": 52.13,
            "M": 110.68,
            "period": 687,
            "q": 1.045,
            "Q": 2,
            "NEO": "Y",
            "PHA": "N",
            "aN": 332.07
        },
        {
            "title": " 36183 (1999 TX16)",
            "a": 1.551,
            "i": 38.22,
            "e": 0.3324,
            "peri": 311.22,
            "M": 8.46,
            "period": 706,
            "q": 1.036,
            "Q": 2.07,
            "NEO": "Y",
            "PHA": "N",
            "aN": 54.64
        },
        {
            "title": " 36236 (1999 VV)",
            "a": 1.333,
            "i": 58.04,
            "e": 0.4238,
            "peri": 19.79,
            "M": 200.5,
            "period": 562,
            "q": 0.768,
            "Q": 1.9,
            "NEO": "Y",
            "PHA": "N",
            "aN": 241.07
        },
        {
            "title": " 36284 (2000 DM8)",
            "a": 1.484,
            "i": 46.76,
            "e": 0.5538,
            "peri": 317.96,
            "M": 128.39,
            "period": 661,
            "q": 0.662,
            "Q": 2.31,
            "NEO": "Y",
            "PHA": "N",
            "aN": 323.15
        },
        {
            "title": " 37336 (2001 RM)",
            "a": 2.254,
            "i": 36.67,
            "e": 0.4831,
            "peri": 118.03,
            "M": 309.55,
            "period": 1240,
            "q": 1.165,
            "Q": 3.34,
            "NEO": "Y",
            "PHA": "N",
            "aN": 223.64
        },
        {
            "title": " 37638 (1993 VB)",
            "a": 1.913,
            "i": 5.08,
            "e": 0.5199,
            "peri": 323.2,
            "M": 236.56,
            "period": 966,
            "q": 0.918,
            "Q": 2.91,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 145.56
        },
        {
            "title": " 37655 Illapa (1994 PM)",
            "a": 1.478,
            "i": 18.03,
            "e": 0.7525,
            "peri": 303.9,
            "M": 254.99,
            "period": 656,
            "q": 0.366,
            "Q": 2.59,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 139.52
        },
        {
            "title": " 38071 (1999 GU3)",
            "a": 2.089,
            "i": 12.74,
            "e": 0.5075,
            "peri": 8.81,
            "M": 162.1,
            "period": 1100,
            "q": 1.029,
            "Q": 3.15,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 195.49
        },
        {
            "title": " 38086 Beowulf (1999 JB)",
            "a": 1.42,
            "i": 23.67,
            "e": 0.5661,
            "peri": 178.97,
            "M": 316.82,
            "period": 618,
            "q": 0.616,
            "Q": 2.22,
            "NEO": "Y",
            "PHA": "N",
            "aN": 165.32
        },
        {
            "title": " 38091 (1999 JT3)",
            "a": 2.17,
            "i": 9.33,
            "e": 0.4012,
            "peri": 225.04,
            "M": 306.59,
            "period": 1170,
            "q": 1.299,
            "Q": 3.04,
            "NEO": "Y",
            "PHA": "N",
            "aN": 64.82
        },
        {
            "title": " 38239 (1999 OR3)",
            "a": 2.036,
            "i": 9.4,
            "e": 0.5757,
            "peri": 28.5,
            "M": 269.1,
            "period": 1060,
            "q": 0.864,
            "Q": 3.21,
            "NEO": "Y",
            "PHA": "N",
            "aN": 199.79
        },
        {
            "title": " 39565 (1992 SL)",
            "a": 1.642,
            "i": 8.6,
            "e": 0.3342,
            "peri": 344.8,
            "M": 95.99,
            "period": 768,
            "q": 1.093,
            "Q": 2.19,
            "NEO": "Y",
            "PHA": "N",
            "aN": 0.94
        },
        {
            "title": " 39572 (1993 DQ1)",
            "a": 2.036,
            "i": 10.03,
            "e": 0.4927,
            "peri": 344.85,
            "M": 205.8,
            "period": 1060,
            "q": 1.033,
            "Q": 3.04,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 313.5
        },
        {
            "title": " 39796 (1997 TD)",
            "a": 2.251,
            "i": 12.91,
            "e": 0.4677,
            "peri": 171.01,
            "M": 10.19,
            "period": 1230,
            "q": 1.198,
            "Q": 3.3,
            "NEO": "Y",
            "PHA": "N",
            "aN": 158.94
        },
        {
            "title": " 40263 (1999 FQ5)",
            "a": 1.495,
            "i": 25.84,
            "e": 0.1611,
            "peri": 198.71,
            "M": 151.82,
            "period": 668,
            "q": 1.254,
            "Q": 1.74,
            "NEO": "Y",
            "PHA": "N",
            "aN": 172.81
        },
        {
            "title": " 40267 (1999 GJ4)",
            "a": 1.339,
            "i": 34.48,
            "e": 0.8084,
            "peri": 211.96,
            "M": 36.46,
            "period": 566,
            "q": 0.256,
            "Q": 2.42,
            "NEO": "Y",
            "PHA": "N",
            "aN": 148.21
        },
        {
            "title": " 40329 (1999 ML)",
            "a": 2.265,
            "i": 2.52,
            "e": 0.4548,
            "peri": 112.01,
            "M": 140.14,
            "period": 1250,
            "q": 1.235,
            "Q": 3.3,
            "NEO": "Y",
            "PHA": "N",
            "aN": 210.91
        },
        {
            "title": " 41429 (2000 GE2)",
            "a": 1.593,
            "i": 2.17,
            "e": 0.5553,
            "peri": 297.2,
            "M": 42.91,
            "period": 734,
            "q": 0.708,
            "Q": 2.48,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 351.91
        },
        {
            "title": " 41440 (2000 HZ23)",
            "a": 1.576,
            "i": 15.11,
            "e": 0.2114,
            "peri": 200.04,
            "M": 105.23,
            "period": 722,
            "q": 1.243,
            "Q": 1.91,
            "NEO": "Y",
            "PHA": "N",
            "aN": 64.04
        },
        {
            "title": " 42286 (2001 TN41)",
            "a": 1.419,
            "i": 24.08,
            "e": 0.3917,
            "peri": 150.95,
            "M": 108.64,
            "period": 618,
            "q": 0.863,
            "Q": 1.98,
            "NEO": "Y",
            "PHA": "N",
            "aN": 55.82
        },
        {
            "title": " 48603 (1995 BC2)",
            "a": 1.918,
            "i": 5.03,
            "e": 0.4299,
            "peri": 81.81,
            "M": 102.88,
            "period": 970,
            "q": 1.093,
            "Q": 2.74,
            "NEO": "Y",
            "PHA": "N",
            "aN": 328.22
        },
        {
            "title": " 52340 (1992 SY)",
            "a": 2.212,
            "i": 8.08,
            "e": 0.5477,
            "peri": 116.34,
            "M": 218.94,
            "period": 1200,
            "q": 1,
            "Q": 3.42,
            "NEO": "Y",
            "PHA": "N",
            "aN": 5.24
        },
        {
            "title": " 52381 (1993 HA)",
            "a": 1.278,
            "i": 7.73,
            "e": 0.1441,
            "peri": 263.85,
            "M": 39.29,
            "period": 528,
            "q": 1.094,
            "Q": 1.46,
            "NEO": "Y",
            "PHA": "N",
            "aN": 183.25
        },
        {
            "title": " 52387 Huitzilopochtli (1993 OM7)",
            "a": 1.282,
            "i": 24.15,
            "e": 0.1896,
            "peri": 195.54,
            "M": 344.42,
            "period": 530,
            "q": 1.039,
            "Q": 1.53,
            "NEO": "Y",
            "PHA": "N",
            "aN": 297.57
        },
        {
            "title": " 52689 (1998 FF2)",
            "a": 1.562,
            "i": 10.98,
            "e": 0.2923,
            "peri": 265.16,
            "M": 163.36,
            "period": 713,
            "q": 1.105,
            "Q": 2.02,
            "NEO": "Y",
            "PHA": "N",
            "aN": 4.66
        },
        {
            "title": " 52750 (1998 KK17)",
            "a": 1.427,
            "i": 11.17,
            "e": 0.5249,
            "peri": 334.15,
            "M": 226.92,
            "period": 623,
            "q": 0.678,
            "Q": 2.18,
            "NEO": "Y",
            "PHA": "N",
            "aN": 141.31
        },
        {
            "title": " 52760 (1998 ML14)",
            "a": 2.409,
            "i": 2.43,
            "e": 0.6233,
            "peri": 20.37,
            "M": 347.09,
            "period": 1370,
            "q": 0.907,
            "Q": 3.91,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 338.68
        },
        {
            "title": " 52761 (1998 MN14)",
            "a": 1.555,
            "i": 19.49,
            "e": 0.2242,
            "peri": 350.5,
            "M": 221.39,
            "period": 708,
            "q": 1.206,
            "Q": 1.9,
            "NEO": "Y",
            "PHA": "N",
            "aN": 258.97
        },
        {
            "title": " 52762 (1998 MT24)",
            "a": 2.416,
            "i": 33.86,
            "e": 0.653,
            "peri": 254.53,
            "M": 29.2,
            "period": 1370,
            "q": 0.838,
            "Q": 3.99,
            "NEO": "Y",
            "PHA": "N",
            "aN": 308.94
        },
        {
            "title": " 52768 (1998 OR2)",
            "a": 2.38,
            "i": 5.88,
            "e": 0.5755,
            "peri": 174.59,
            "M": 81.21,
            "period": 1340,
            "q": 1.01,
            "Q": 3.75,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 26.94
        },
        {
            "title": " 53110 (1999 AR7)",
            "a": 1.644,
            "i": 40.63,
            "e": 0.2144,
            "peri": 58.21,
            "M": 35.5,
            "period": 770,
            "q": 1.292,
            "Q": 2,
            "NEO": "Y",
            "PHA": "N",
            "aN": 85.42
        },
        {
            "title": " 53319 (1999 JM8)",
            "a": 2.724,
            "i": 13.84,
            "e": 0.6414,
            "peri": 166.8,
            "M": 228.77,
            "period": 1640,
            "q": 0.977,
            "Q": 4.47,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 133.62
        },
        {
            "title": " 53409 (1999 LU7)",
            "a": 2.101,
            "i": 10.88,
            "e": 0.6282,
            "peri": 147.77,
            "M": 84.64,
            "period": 1110,
            "q": 0.781,
            "Q": 3.42,
            "NEO": "Y",
            "PHA": "N",
            "aN": 206.68
        },
        {
            "title": " 53426 (1999 SL5)",
            "a": 1.923,
            "i": 22.77,
            "e": 0.5391,
            "peri": 43.36,
            "M": 167.9,
            "period": 974,
            "q": 0.886,
            "Q": 2.96,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 239.06
        },
        {
            "title": " 53429 (1999 TF5)",
            "a": 2.022,
            "i": 26.78,
            "e": 0.641,
            "peri": 64.09,
            "M": 281.57,
            "period": 1050,
            "q": 0.726,
            "Q": 3.32,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 199.16
        },
        {
            "title": " 53430 (1999 TY16)",
            "a": 2.099,
            "i": 60.41,
            "e": 0.4035,
            "peri": 156.95,
            "M": 90.24,
            "period": 1110,
            "q": 1.252,
            "Q": 2.95,
            "NEO": "Y",
            "PHA": "N",
            "aN": 241.92
        },
        {
            "title": " 53435 Leonard (1999 VM40)",
            "a": 2.31,
            "i": 15.35,
            "e": 0.4833,
            "peri": 354.47,
            "M": 49.36,
            "period": 1280,
            "q": 1.194,
            "Q": 3.43,
            "NEO": "Y",
            "PHA": "N",
            "aN": 51.35
        },
        {
            "title": " 53550 (2000 BF19)",
            "a": 1.495,
            "i": 7.17,
            "e": 0.4196,
            "peri": 324.95,
            "M": 67.25,
            "period": 668,
            "q": 0.868,
            "Q": 2.12,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 313.14
        },
        {
            "title": " 53789 (2000 ED104)",
            "a": 1.371,
            "i": 40.78,
            "e": 0.2692,
            "peri": 218.35,
            "M": 236.89,
            "period": 586,
            "q": 1.002,
            "Q": 1.74,
            "NEO": "Y",
            "PHA": "Y",
            "aN": 190.02
        },
        {
            "title": " 54071 (2000 GQ146)",
            "a": 1.329,
            "i": 23.44,
            "e": 0.1973,
            "peri": 128.31,
            "M": 32.86,
            "period": 560,
            "q": 1.067,
            "Q": 1.59,
            "NEO": "Y",
            "PHA": "N",
            "aN": 36.34
        },
        {
            "title": " 54401 (2000 LM)",
            "a": 1.711,
            "i": 18.95,
            "e": 0.2624,
            "peri": 67.06,
            "M": 297.05,
            "period": 817,
            "q": 1.262,
            "Q": 2.16,
            "NEO": "Y",
            "PHA": "N",
            "aN": 240.84
        },
        {
            "title": " 54509 YORP (2000 PH5)",
            "a": 1.006,
            "i": 1.6,
            "e": 0.23,
            "peri": 279,
            "M": 99.36,
            "period": 368,
            "q": 0.775,
            "Q": 1.24,
            "NEO": "Y",
            "PHA": "N",
            "aN": 278.19
        },
        {
            "title": " 54660 (2000 UJ1)",
            "a": 1.477,
            "i": 46.69,
            "e": 0.2807,
            "peri": 158.03,
            "M": 127.34,
            "period": 655,
            "q": 1.062,
            "Q": 1.89,
            "NEO": "Y",
            "PHA": "N",
            "aN": 223.71
        },
        {
            "title": " 54686 (2001 DU8)",
            "a": 1.777,
            "i": 33.21,
            "e": 0.3419,
            "peri": 265.9,
            "M": 47.38,
            "period": 865,
            "q": 1.169,
            "Q": 2.38,
            "NEO": "Y",
            "PHA": "N",
            "aN": 161.69
        },
        {
            "title": " 54690 (2001 EB)",
            "a": 1.63,
            "i": 35.36,
            "e": 0.2564,
            "peri": 99.6,
            "M": 155.05,
            "period": 760,
            "q": 1.212,
            "Q": 2.05,
            "NEO": "Y",
            "PHA": "N",
            "aN": 33.51
        },
        {
            "title": " 54789 (2001 MZ7)",
            "a": 1.776,
            "i": 24.46,
            "e": 0.2872,
            "peri": 20.04,
            "M": 65.45,
            "period": 865,
            "q": 1.266,
            "Q": 2.29,
            "NEO": "Y",
            "PHA": "N",
            "aN": 130.05
        },
        {
            "title": "     1 Ceres (A801 AA)",
            "a": 2.767,
            "i": 10.59,
            "e": 0.0792,
            "peri": 73.29,
            "M": 145.85,
            "period": 1680,
            "q": 2.548,
            "Q": 2.99,
            "NEO": "N",
            "PHA": "N",
            "aN": 80.25
        },
        {
            "title": "     2 Pallas (A802 FA)",
            "a": 2.77,
            "i": 34.92,
            "e": 0.2304,
            "peri": 310.89,
            "M": 126.07,
            "period": 1680,
            "q": 2.132,
            "Q": 3.41,
            "NEO": "N",
            "PHA": "N",
            "aN": 172.91
        },
        {
            "title": "     3 Juno (A804 RA)",
            "a": 2.67,
            "i": 12.99,
            "e": 0.2561,
            "peri": 247.82,
            "M": 127.33,
            "period": 1590,
            "q": 1.986,
            "Q": 3.35,
            "NEO": "N",
            "PHA": "N",
            "aN": 169.84
        },
        {
            "title": "     4 Vesta (A807 FA)",
            "a": 2.361,
            "i": 7.14,
            "e": 0.09,
            "peri": 151.68,
            "M": 278.02,
            "period": 1330,
            "q": 2.148,
            "Q": 2.57,
            "NEO": "N",
            "PHA": "N",
            "aN": 103.7
        },
        {
            "title": "     5 Astraea (A845 XA)",
            "a": 2.576,
            "i": 5.36,
            "e": 0.1873,
            "peri": 359.26,
            "M": 38.64,
            "period": 1510,
            "q": 2.094,
            "Q": 3.06,
            "NEO": "N",
            "PHA": "N",
            "aN": 141.46
        },
        {
            "title": "     6 Hebe (A847 NA)",
            "a": 2.426,
            "i": 14.73,
            "e": 0.2024,
            "peri": 239.65,
            "M": 248.27,
            "period": 1380,
            "q": 1.935,
            "Q": 2.92,
            "NEO": "N",
            "PHA": "N",
            "aN": 138.62
        },
        {
            "title": "     7 Iris (A847 PA)",
            "a": 2.386,
            "i": 5.52,
            "e": 0.2299,
            "peri": 145.52,
            "M": 314.76,
            "period": 1350,
            "q": 1.838,
            "Q": 2.93,
            "NEO": "N",
            "PHA": "N",
            "aN": 259.5
        },
        {
            "title": "     8 Flora (A847 UA)",
            "a": 2.201,
            "i": 5.89,
            "e": 0.1566,
            "peri": 285.43,
            "M": 78.15,
            "period": 1190,
            "q": 1.856,
            "Q": 2.55,
            "NEO": "N",
            "PHA": "N",
            "aN": 110.85
        },
        {
            "title": "     9 Metis (A848 HA)",
            "a": 2.386,
            "i": 5.58,
            "e": 0.1228,
            "peri": 5.77,
            "M": 92.38,
            "period": 1350,
            "q": 2.093,
            "Q": 2.68,
            "NEO": "N",
            "PHA": "N",
            "aN": 68.87
        },
        {
            "title": "    10 Hygiea (A849 GA)",
            "a": 3.141,
            "i": 3.83,
            "e": 0.1104,
            "peri": 312.63,
            "M": 145.94,
            "period": 2030,
            "q": 2.794,
            "Q": 3.49,
            "NEO": "N",
            "PHA": "N",
            "aN": 283.15
        },
        {
            "title": "    11 Parthenope (A850 JA)",
            "a": 2.453,
            "i": 4.63,
            "e": 0.0994,
            "peri": 196.07,
            "M": 71.5,
            "period": 1400,
            "q": 2.209,
            "Q": 2.7,
            "NEO": "N",
            "PHA": "N",
            "aN": 125.51
        },
        {
            "title": "    12 Victoria (A850 RA)",
            "a": 2.334,
            "i": 8.37,
            "e": 0.2201,
            "peri": 69.55,
            "M": 326.36,
            "period": 1300,
            "q": 1.82,
            "Q": 2.85,
            "NEO": "N",
            "PHA": "N",
            "aN": 235.36
        },
        {
            "title": "    13 Egeria (A850 VA)",
            "a": 2.578,
            "i": 16.53,
            "e": 0.0854,
            "peri": 79.22,
            "M": 305.55,
            "period": 1510,
            "q": 2.358,
            "Q": 2.8,
            "NEO": "N",
            "PHA": "N",
            "aN": 43.21
        },
        {
            "title": "    14 Irene (A851 KA)",
            "a": 2.59,
            "i": 9.13,
            "e": 0.163,
            "peri": 98.05,
            "M": 278.47,
            "period": 1520,
            "q": 2.167,
            "Q": 3.01,
            "NEO": "N",
            "PHA": "N",
            "aN": 86.01
        },
        {
            "title": "    15 Eunomia (A851 OA)",
            "a": 2.644,
            "i": 11.76,
            "e": 0.1876,
            "peri": 98.77,
            "M": 21.75,
            "period": 1570,
            "q": 2.148,
            "Q": 3.14,
            "NEO": "N",
            "PHA": "N",
            "aN": 292.89
        },
        {
            "title": "    16 Psyche (A852 FA)",
            "a": 2.922,
            "i": 3.1,
            "e": 0.1341,
            "peri": 229.59,
            "M": 321.87,
            "period": 1820,
            "q": 2.53,
            "Q": 3.31,
            "NEO": "N",
            "PHA": "N",
            "aN": 150.02
        },
        {
            "title": "    17 Thetis (A852 HA)",
            "a": 2.471,
            "i": 5.59,
            "e": 0.1322,
            "peri": 135.69,
            "M": 91.44,
            "period": 1420,
            "q": 2.144,
            "Q": 2.8,
            "NEO": "N",
            "PHA": "N",
            "aN": 125.53
        },
        {
            "title": "    18 Melpomene (A852 MA)",
            "a": 2.295,
            "i": 10.13,
            "e": 0.2183,
            "peri": 228.05,
            "M": 113.87,
            "period": 1270,
            "q": 1.794,
            "Q": 2.8,
            "NEO": "N",
            "PHA": "N",
            "aN": 150.34
        },
        {
            "title": "    19 Fortuna (A852 QA)",
            "a": 2.442,
            "i": 1.57,
            "e": 0.1575,
            "peri": 182.67,
            "M": 353.08,
            "period": 1390,
            "q": 2.057,
            "Q": 2.83,
            "NEO": "N",
            "PHA": "N",
            "aN": 211.04
        },
        {
            "title": "    20 Massalia (A852 SA)",
            "a": 2.408,
            "i": 0.71,
            "e": 0.1437,
            "peri": 257.46,
            "M": 284.31,
            "period": 1360,
            "q": 2.062,
            "Q": 2.75,
            "NEO": "N",
            "PHA": "N",
            "aN": 205.98
        },
        {
            "title": "    21 Lutetia (A852 VA)",
            "a": 2.434,
            "i": 3.06,
            "e": 0.1647,
            "peri": 250.03,
            "M": 142.87,
            "period": 1390,
            "q": 2.033,
            "Q": 2.84,
            "NEO": "N",
            "PHA": "N",
            "aN": 80.84
        },
        {
            "title": "    22 Kalliope (A852 WA)",
            "a": 2.911,
            "i": 13.7,
            "e": 0.0989,
            "peri": 358,
            "M": 231.49,
            "period": 1810,
            "q": 2.623,
            "Q": 3.2,
            "NEO": "N",
            "PHA": "N",
            "aN": 65.97
        },
        {
            "title": "    23 Thalia (A852 XA)",
            "a": 2.629,
            "i": 10.11,
            "e": 0.2311,
            "peri": 61.59,
            "M": 77.78,
            "period": 1560,
            "q": 2.021,
            "Q": 3.24,
            "NEO": "N",
            "PHA": "N",
            "aN": 66.49
        },
        {
            "title": "    24 Themis (A853 GA)",
            "a": 3.143,
            "i": 0.74,
            "e": 0.1153,
            "peri": 108.96,
            "M": 346.13,
            "period": 2040,
            "q": 2.78,
            "Q": 3.51,
            "NEO": "N",
            "PHA": "N",
            "aN": 36.39
        },
        {
            "title": "    25 Phocaea (A853 GB)",
            "a": 2.4,
            "i": 21.61,
            "e": 0.2542,
            "peri": 90.2,
            "M": 343.19,
            "period": 1360,
            "q": 1.79,
            "Q": 3.01,
            "NEO": "N",
            "PHA": "N",
            "aN": 214.09
        },
        {
            "title": "    26 Proserpina (A853 JA)",
            "a": 2.658,
            "i": 3.56,
            "e": 0.0882,
            "peri": 195.11,
            "M": 199.48,
            "period": 1580,
            "q": 2.424,
            "Q": 2.89,
            "NEO": "N",
            "PHA": "N",
            "aN": 45.75
        },
        {
            "title": "    27 Euterpe (A853 VA)",
            "a": 2.348,
            "i": 1.58,
            "e": 0.1714,
            "peri": 356.48,
            "M": 163.43,
            "period": 1310,
            "q": 1.945,
            "Q": 2.75,
            "NEO": "N",
            "PHA": "N",
            "aN": 94.77
        },
        {
            "title": "    28 Bellona (A854 EA)",
            "a": 2.778,
            "i": 9.42,
            "e": 0.1493,
            "peri": 343.39,
            "M": 340.34,
            "period": 1690,
            "q": 2.363,
            "Q": 3.19,
            "NEO": "N",
            "PHA": "N",
            "aN": 144.16
        },
        {
            "title": "    29 Amphitrite (A854 EB)",
            "a": 2.554,
            "i": 6.08,
            "e": 0.0736,
            "peri": 62.01,
            "M": 48.4,
            "period": 1490,
            "q": 2.366,
            "Q": 2.74,
            "NEO": "N",
            "PHA": "N",
            "aN": 356.26
        },
        {
            "title": "    30 Urania (A854 OA)",
            "a": 2.366,
            "i": 2.09,
            "e": 0.1269,
            "peri": 87.1,
            "M": 211.29,
            "period": 1330,
            "q": 2.066,
            "Q": 2.67,
            "NEO": "N",
            "PHA": "N",
            "aN": 307.4
        },
        {
            "title": "    31 Euphrosyne (A854 RA)",
            "a": 3.16,
            "i": 26.32,
            "e": 0.216,
            "peri": 61.86,
            "M": 77.86,
            "period": 2050,
            "q": 2.478,
            "Q": 3.84,
            "NEO": "N",
            "PHA": "N",
            "aN": 30.8
        },
        {
            "title": "    32 Pomona (A854 UA)",
            "a": 2.587,
            "i": 5.52,
            "e": 0.0816,
            "peri": 338.15,
            "M": 146.94,
            "period": 1520,
            "q": 2.376,
            "Q": 2.8,
            "NEO": "N",
            "PHA": "N",
            "aN": 220.36
        },
        {
            "title": "    33 Polyhymnia (A854 UB)",
            "a": 2.873,
            "i": 1.85,
            "e": 0.3317,
            "peri": 338.65,
            "M": 26.28,
            "period": 1780,
            "q": 1.92,
            "Q": 3.83,
            "NEO": "N",
            "PHA": "N",
            "aN": 8.43
        },
        {
            "title": "    34 Circe (A855 GA)",
            "a": 2.686,
            "i": 5.5,
            "e": 0.1068,
            "peri": 329.83,
            "M": 215.23,
            "period": 1610,
            "q": 2.399,
            "Q": 2.97,
            "NEO": "N",
            "PHA": "N",
            "aN": 184.33
        },
        {
            "title": "    35 Leukothea (A855 HA)",
            "a": 3.01,
            "i": 7.86,
            "e": 0.2188,
            "peri": 214.69,
            "M": 234.16,
            "period": 1910,
            "q": 2.351,
            "Q": 3.67,
            "NEO": "N",
            "PHA": "N",
            "aN": 353.27
        },
        {
            "title": "    36 Atalante (A855 TA)",
            "a": 2.746,
            "i": 18.37,
            "e": 0.3065,
            "peri": 47.84,
            "M": 12.8,
            "period": 1660,
            "q": 1.904,
            "Q": 3.59,
            "NEO": "N",
            "PHA": "N",
            "aN": 358.18
        },
        {
            "title": "    37 Fides (A855 TB)",
            "a": 2.642,
            "i": 3.07,
            "e": 0.175,
            "peri": 62.2,
            "M": 81.2,
            "period": 1570,
            "q": 2.18,
            "Q": 3.1,
            "NEO": "N",
            "PHA": "N",
            "aN": 7.24
        },
        {
            "title": "    38 Leda (A856 AA)",
            "a": 2.742,
            "i": 6.95,
            "e": 0.1509,
            "peri": 169.65,
            "M": 79.1,
            "period": 1660,
            "q": 2.328,
            "Q": 3.16,
            "NEO": "N",
            "PHA": "N",
            "aN": 295.5
        },
        {
            "title": "    39 Laetitia (A856 CA)",
            "a": 2.768,
            "i": 10.37,
            "e": 0.112,
            "peri": 209.96,
            "M": 8.48,
            "period": 1680,
            "q": 2.458,
            "Q": 3.08,
            "NEO": "N",
            "PHA": "N",
            "aN": 156.93
        },
        {
            "title": "    40 Harmonia (A856 FA)",
            "a": 2.267,
            "i": 4.26,
            "e": 0.0461,
            "peri": 269.36,
            "M": 325.29,
            "period": 1250,
            "q": 2.163,
            "Q": 2.37,
            "NEO": "N",
            "PHA": "N",
            "aN": 94.16
        },
        {
            "title": "    41 Daphne (A856 KA)",
            "a": 2.769,
            "i": 15.74,
            "e": 0.2717,
            "peri": 46.49,
            "M": 203.19,
            "period": 1680,
            "q": 2.017,
            "Q": 3.52,
            "NEO": "N",
            "PHA": "N",
            "aN": 177.9
        },
        {
            "title": "    42 Isis (A856 KB)",
            "a": 2.443,
            "i": 8.51,
            "e": 0.222,
            "peri": 237.26,
            "M": 359.93,
            "period": 1390,
            "q": 1.9,
            "Q": 2.98,
            "NEO": "N",
            "PHA": "N",
            "aN": 84.17
        },
        {
            "title": "    43 Ariadne (A857 GA)",
            "a": 2.203,
            "i": 3.47,
            "e": 0.1685,
            "peri": 16.13,
            "M": 20.93,
            "period": 1190,
            "q": 1.832,
            "Q": 2.57,
            "NEO": "N",
            "PHA": "N",
            "aN": 264.75
        },
        {
            "title": "    44 Nysa (A857 KA)",
            "a": 2.422,
            "i": 3.71,
            "e": 0.1496,
            "peri": 344.14,
            "M": 244.39,
            "period": 1380,
            "q": 2.06,
            "Q": 2.78,
            "NEO": "N",
            "PHA": "N",
            "aN": 131.49
        },
        {
            "title": "    45 Eugenia (A857 MA)",
            "a": 2.72,
            "i": 6.61,
            "e": 0.083,
            "peri": 87.33,
            "M": 118.6,
            "period": 1640,
            "q": 2.494,
            "Q": 2.95,
            "NEO": "N",
            "PHA": "N",
            "aN": 147.58
        },
        {
            "title": "    46 Hestia (A857 QA)",
            "a": 2.525,
            "i": 2.35,
            "e": 0.1722,
            "peri": 177.08,
            "M": 201.51,
            "period": 1470,
            "q": 2.09,
            "Q": 2.96,
            "NEO": "N",
            "PHA": "N",
            "aN": 181.07
        },
        {
            "title": "    47 Aglaja (A857 RA)",
            "a": 2.885,
            "i": 4.97,
            "e": 0.131,
            "peri": 315.9,
            "M": 94.01,
            "period": 1790,
            "q": 2.507,
            "Q": 3.26,
            "NEO": "N",
            "PHA": "N",
            "aN": 2.97
        },
        {
            "title": "    48 Doris (A857 SA)",
            "a": 3.112,
            "i": 6.56,
            "e": 0.0665,
            "peri": 251.06,
            "M": 70.22,
            "period": 2000,
            "q": 2.905,
            "Q": 3.32,
            "NEO": "N",
            "PHA": "N",
            "aN": 183.43
        },
        {
            "title": "    49 Pales (A857 SB)",
            "a": 3.099,
            "i": 3.2,
            "e": 0.2216,
            "peri": 113.38,
            "M": 240.78,
            "period": 1990,
            "q": 2.412,
            "Q": 3.79,
            "NEO": "N",
            "PHA": "N",
            "aN": 284.99
        },
        {
            "title": "    50 Virginia (A857 TA)",
            "a": 2.652,
            "i": 2.84,
            "e": 0.2848,
            "peri": 200.05,
            "M": 255.35,
            "period": 1580,
            "q": 1.897,
            "Q": 3.41,
            "NEO": "N",
            "PHA": "N",
            "aN": 173.46
        },
        {
            "title": "    51 Nemausa (A858 BA)",
            "a": 2.366,
            "i": 9.97,
            "e": 0.0661,
            "peri": 1.89,
            "M": 278.57,
            "period": 1330,
            "q": 2.21,
            "Q": 2.52,
            "NEO": "N",
            "PHA": "N",
            "aN": 175.9
        },
        {
            "title": "    52 Europa (A858 CA)",
            "a": 3.092,
            "i": 7.48,
            "e": 0.1117,
            "peri": 342.95,
            "M": 239.99,
            "period": 1990,
            "q": 2.747,
            "Q": 3.44,
            "NEO": "N",
            "PHA": "N",
            "aN": 128.58
        },
        {
            "title": "    53 Kalypso (A858 GA)",
            "a": 2.619,
            "i": 5.18,
            "e": 0.2028,
            "peri": 314.31,
            "M": 168.2,
            "period": 1550,
            "q": 2.088,
            "Q": 3.15,
            "NEO": "N",
            "PHA": "N",
            "aN": 143.44
        },
        {
            "title": "    54 Alexandra (A858 RA)",
            "a": 2.713,
            "i": 11.8,
            "e": 0.1969,
            "peri": 345.63,
            "M": 99.25,
            "period": 1630,
            "q": 2.179,
            "Q": 3.25,
            "NEO": "N",
            "PHA": "N",
            "aN": 313.17
        },
        {
            "title": "    55 Pandora (A858 RB)",
            "a": 2.759,
            "i": 7.18,
            "e": 0.145,
            "peri": 5.17,
            "M": 71.2,
            "period": 1670,
            "q": 2.359,
            "Q": 3.16,
            "NEO": "N",
            "PHA": "N",
            "aN": 10.31
        },
        {
            "title": "    56 Melete (A857 RB)",
            "a": 2.597,
            "i": 8.08,
            "e": 0.2371,
            "peri": 104.9,
            "M": 357.84,
            "period": 1530,
            "q": 1.981,
            "Q": 3.21,
            "NEO": "N",
            "PHA": "N",
            "aN": 192.94
        },
        {
            "title": "    57 Mnemosyne (A859 SA)",
            "a": 3.155,
            "i": 15.24,
            "e": 0.1084,
            "peri": 210.87,
            "M": 134.96,
            "period": 2050,
            "q": 2.813,
            "Q": 3.5,
            "NEO": "N",
            "PHA": "N",
            "aN": 198.9
        },
        {
            "title": "    58 Concordia (A860 FA)",
            "a": 2.7,
            "i": 5.07,
            "e": 0.0454,
            "peri": 33.91,
            "M": 19.59,
            "period": 1620,
            "q": 2.577,
            "Q": 2.82,
            "NEO": "N",
            "PHA": "N",
            "aN": 161.06
        },
        {
            "title": "    59 Elpis (A860 RA)",
            "a": 2.714,
            "i": 8.65,
            "e": 0.1168,
            "peri": 211.04,
            "M": 240.23,
            "period": 1630,
            "q": 2.397,
            "Q": 3.03,
            "NEO": "N",
            "PHA": "N",
            "aN": 169.92
        },
        {
            "title": "    60 Echo (A860 RB)",
            "a": 2.392,
            "i": 3.6,
            "e": 0.1845,
            "peri": 270.78,
            "M": 21.62,
            "period": 1350,
            "q": 1.951,
            "Q": 2.83,
            "NEO": "N",
            "PHA": "N",
            "aN": 191.53
        },
        {
            "title": "    61 Danae (A860 RC)",
            "a": 2.986,
            "i": 18.2,
            "e": 0.1641,
            "peri": 12.86,
            "M": 294.01,
            "period": 1880,
            "q": 2.496,
            "Q": 3.48,
            "NEO": "N",
            "PHA": "N",
            "aN": 333.55
        },
        {
            "title": "    62 Erato (A860 RD)",
            "a": 3.131,
            "i": 2.24,
            "e": 0.1681,
            "peri": 277.65,
            "M": 234.49,
            "period": 2020,
            "q": 2.604,
            "Q": 3.66,
            "NEO": "N",
            "PHA": "N",
            "aN": 125.1
        },
        {
            "title": "    63 Ausonia (A861 CA)",
            "a": 2.395,
            "i": 5.77,
            "e": 0.1282,
            "peri": 295.71,
            "M": 311.64,
            "period": 1350,
            "q": 2.088,
            "Q": 2.7,
            "NEO": "N",
            "PHA": "N",
            "aN": 337.69
        },
        {
            "title": "    64 Angelina (A861 EA)",
            "a": 2.682,
            "i": 1.31,
            "e": 0.1263,
            "peri": 181,
            "M": 125.2,
            "period": 1600,
            "q": 2.343,
            "Q": 3.02,
            "NEO": "N",
            "PHA": "N",
            "aN": 308.96
        },
        {
            "title": "    65 Cybele (A861 EB)",
            "a": 3.413,
            "i": 3.56,
            "e": 0.1265,
            "peri": 103.65,
            "M": 210.43,
            "period": 2300,
            "q": 2.981,
            "Q": 3.84,
            "NEO": "N",
            "PHA": "N",
            "aN": 155.14
        },
        {
            "title": "    66 Maja (A861 GA)",
            "a": 2.646,
            "i": 3.04,
            "e": 0.1724,
            "peri": 43.39,
            "M": 117.75,
            "period": 1570,
            "q": 2.19,
            "Q": 3.1,
            "NEO": "N",
            "PHA": "N",
            "aN": 7.49
        },
        {
            "title": "    67 Asia (A861 HA)",
            "a": 2.423,
            "i": 6.03,
            "e": 0.1846,
            "peri": 107.25,
            "M": 81.31,
            "period": 1380,
            "q": 1.976,
            "Q": 2.87,
            "NEO": "N",
            "PHA": "N",
            "aN": 202.38
        },
        {
            "title": "    68 Leto (A861 HB)",
            "a": 2.783,
            "i": 7.96,
            "e": 0.1845,
            "peri": 304.82,
            "M": 325.79,
            "period": 1700,
            "q": 2.27,
            "Q": 3.3,
            "NEO": "N",
            "PHA": "N",
            "aN": 44.05
        },
        {
            "title": "    69 Hesperia (A861 HC)",
            "a": 2.98,
            "i": 8.59,
            "e": 0.1698,
            "peri": 288.23,
            "M": 326,
            "period": 1880,
            "q": 2.474,
            "Q": 3.49,
            "NEO": "N",
            "PHA": "N",
            "aN": 184.95
        },
        {
            "title": "    70 Panopaea (A861 JA)",
            "a": 2.614,
            "i": 11.6,
            "e": 0.1827,
            "peri": 255.5,
            "M": 176.17,
            "period": 1540,
            "q": 2.136,
            "Q": 3.09,
            "NEO": "N",
            "PHA": "N",
            "aN": 47.64
        },
        {
            "title": "    71 Niobe (A861 PA)",
            "a": 2.754,
            "i": 23.24,
            "e": 0.1768,
            "peri": 267.06,
            "M": 334.91,
            "period": 1670,
            "q": 2.267,
            "Q": 3.24,
            "NEO": "N",
            "PHA": "N",
            "aN": 315.91
        },
        {
            "title": "    72 Feronia (A861 KA)",
            "a": 2.266,
            "i": 5.42,
            "e": 0.1215,
            "peri": 102.84,
            "M": 224.6,
            "period": 1250,
            "q": 1.99,
            "Q": 2.54,
            "NEO": "N",
            "PHA": "N",
            "aN": 207.93
        },
        {
            "title": "    73 Klytia (A862 GA)",
            "a": 2.665,
            "i": 2.37,
            "e": 0.0422,
            "peri": 56.34,
            "M": 245.87,
            "period": 1590,
            "q": 2.552,
            "Q": 2.78,
            "NEO": "N",
            "PHA": "N",
            "aN": 6.84
        },
        {
            "title": "    74 Galatea (A862 QA)",
            "a": 2.78,
            "i": 4.07,
            "e": 0.2362,
            "peri": 174.86,
            "M": 339.33,
            "period": 1690,
            "q": 2.123,
            "Q": 3.44,
            "NEO": "N",
            "PHA": "N",
            "aN": 197.11
        },
        {
            "title": "    75 Eurydike (A862 SA)",
            "a": 2.675,
            "i": 4.99,
            "e": 0.3039,
            "peri": 339.62,
            "M": 52.25,
            "period": 1600,
            "q": 1.862,
            "Q": 3.49,
            "NEO": "N",
            "PHA": "N",
            "aN": 359.3
        },
        {
            "title": "    76 Freia (A862 UA)",
            "a": 3.41,
            "i": 2.12,
            "e": 0.1675,
            "peri": 252.07,
            "M": 236.99,
            "period": 2300,
            "q": 2.839,
            "Q": 3.98,
            "NEO": "N",
            "PHA": "N",
            "aN": 204.28
        },
        {
            "title": "    77 Frigga (A862 VA)",
            "a": 2.669,
            "i": 2.42,
            "e": 0.1339,
            "peri": 61.34,
            "M": 16.12,
            "period": 1590,
            "q": 2.312,
            "Q": 3.03,
            "NEO": "N",
            "PHA": "N",
            "aN": 1.08
        },
        {
            "title": "    78 Diana (A863 EA)",
            "a": 2.622,
            "i": 8.68,
            "e": 0.2034,
            "peri": 153.2,
            "M": 62.32,
            "period": 1550,
            "q": 2.089,
            "Q": 3.16,
            "NEO": "N",
            "PHA": "N",
            "aN": 333.3
        },
        {
            "title": "    79 Eurynome (A863 RA)",
            "a": 2.445,
            "i": 4.61,
            "e": 0.1912,
            "peri": 201.51,
            "M": 24.03,
            "period": 1400,
            "q": 1.977,
            "Q": 2.91,
            "NEO": "N",
            "PHA": "N",
            "aN": 206.52
        },
        {
            "title": "    80 Sappho (A864 JA)",
            "a": 2.296,
            "i": 8.68,
            "e": 0.1997,
            "peri": 139.61,
            "M": 304.01,
            "period": 1270,
            "q": 1.838,
            "Q": 2.75,
            "NEO": "N",
            "PHA": "N",
            "aN": 218.64
        },
        {
            "title": "    81 Terpsichore (A864 SA)",
            "a": 2.853,
            "i": 7.8,
            "e": 0.2121,
            "peri": 51.29,
            "M": 36.7,
            "period": 1760,
            "q": 2.248,
            "Q": 3.46,
            "NEO": "N",
            "PHA": "N",
            "aN": 0.9
        },
        {
            "title": "    82 Alkmene (A864 WA)",
            "a": 2.762,
            "i": 2.83,
            "e": 0.2209,
            "peri": 110.88,
            "M": 245.27,
            "period": 1680,
            "q": 2.152,
            "Q": 3.37,
            "NEO": "N",
            "PHA": "N",
            "aN": 25.43
        },
        {
            "title": "    83 Beatrix (A865 HA)",
            "a": 2.432,
            "i": 4.97,
            "e": 0.0828,
            "peri": 169.98,
            "M": 27.93,
            "period": 1390,
            "q": 2.23,
            "Q": 2.63,
            "NEO": "N",
            "PHA": "N",
            "aN": 27.67
        },
        {
            "title": "    84 Klio (A865 QA)",
            "a": 2.363,
            "i": 9.31,
            "e": 0.2356,
            "peri": 15.07,
            "M": 290.35,
            "period": 1330,
            "q": 1.806,
            "Q": 2.92,
            "NEO": "N",
            "PHA": "N",
            "aN": 327.5
        },
        {
            "title": "    85 Io (A865 SA)",
            "a": 2.654,
            "i": 11.96,
            "e": 0.1934,
            "peri": 122.89,
            "M": 317.06,
            "period": 1580,
            "q": 2.141,
            "Q": 3.17,
            "NEO": "N",
            "PHA": "N",
            "aN": 203.05
        },
        {
            "title": "    86 Semele (A866 AA)",
            "a": 3.104,
            "i": 4.82,
            "e": 0.2166,
            "peri": 309.07,
            "M": 351.88,
            "period": 2000,
            "q": 2.432,
            "Q": 3.78,
            "NEO": "N",
            "PHA": "N",
            "aN": 86.07
        },
        {
            "title": "    87 Sylvia (A866 KA)",
            "a": 3.477,
            "i": 10.88,
            "e": 0.0939,
            "peri": 264.63,
            "M": 35.44,
            "period": 2370,
            "q": 3.151,
            "Q": 3.8,
            "NEO": "N",
            "PHA": "N",
            "aN": 73.01
        },
        {
            "title": "    88 Thisbe (A866 LA)",
            "a": 2.771,
            "i": 5.22,
            "e": 0.1634,
            "peri": 37.05,
            "M": 115.9,
            "period": 1690,
            "q": 2.319,
            "Q": 3.22,
            "NEO": "N",
            "PHA": "N",
            "aN": 276.32
        },
        {
            "title": "    89 Julia (A866 PA)",
            "a": 2.551,
            "i": 16.12,
            "e": 0.184,
            "peri": 45.17,
            "M": 261.66,
            "period": 1490,
            "q": 2.082,
            "Q": 3.02,
            "NEO": "N",
            "PHA": "N",
            "aN": 311.53
        },
        {
            "title": "    90 Antiope (A866 TA)",
            "a": 3.145,
            "i": 2.21,
            "e": 0.1711,
            "peri": 244.5,
            "M": 138.15,
            "period": 2040,
            "q": 2.607,
            "Q": 3.68,
            "NEO": "N",
            "PHA": "N",
            "aN": 69.92
        },
        {
            "title": "    91 Aegina (A866 VA)",
            "a": 2.589,
            "i": 2.1,
            "e": 0.1076,
            "peri": 74.47,
            "M": 279.59,
            "period": 1520,
            "q": 2.31,
            "Q": 2.87,
            "NEO": "N",
            "PHA": "N",
            "aN": 10.42
        },
        {
            "title": "    92 Undina (A867 NA)",
            "a": 3.184,
            "i": 9.92,
            "e": 0.1051,
            "peri": 236.84,
            "M": 168.62,
            "period": 2080,
            "q": 2.85,
            "Q": 3.52,
            "NEO": "N",
            "PHA": "N",
            "aN": 101.4
        },
        {
            "title": "    93 Minerva (A867 QA)",
            "a": 2.755,
            "i": 8.54,
            "e": 0.1422,
            "peri": 275.81,
            "M": 186.88,
            "period": 1670,
            "q": 2.363,
            "Q": 3.15,
            "NEO": "N",
            "PHA": "N",
            "aN": 3.84
        },
        {
            "title": "    94 Aurora (A867 RA)",
            "a": 3.154,
            "i": 7.97,
            "e": 0.0957,
            "peri": 60.47,
            "M": 300.3,
            "period": 2050,
            "q": 2.852,
            "Q": 3.46,
            "NEO": "N",
            "PHA": "N",
            "aN": 2.54
        },
        {
            "title": "    95 Arethusa (A867 WA)",
            "a": 3.064,
            "i": 13.01,
            "e": 0.153,
            "peri": 152.77,
            "M": 82.71,
            "period": 1960,
            "q": 2.595,
            "Q": 3.53,
            "NEO": "N",
            "PHA": "N",
            "aN": 242.94
        },
        {
            "title": "    96 Aegle (A868 DA)",
            "a": 3.05,
            "i": 15.98,
            "e": 0.1419,
            "peri": 207.97,
            "M": 115.11,
            "period": 1950,
            "q": 2.617,
            "Q": 3.48,
            "NEO": "N",
            "PHA": "N",
            "aN": 321.47
        },
        {
            "title": "    97 Klotho (A868 DB)",
            "a": 2.668,
            "i": 11.78,
            "e": 0.2578,
            "peri": 268.38,
            "M": 43.62,
            "period": 1590,
            "q": 1.98,
            "Q": 3.36,
            "NEO": "N",
            "PHA": "N",
            "aN": 159.59
        },
        {
            "title": "    98 Ianthe (A868 HA)",
            "a": 2.686,
            "i": 15.58,
            "e": 0.1878,
            "peri": 158.29,
            "M": 213.68,
            "period": 1610,
            "q": 2.182,
            "Q": 3.19,
            "NEO": "N",
            "PHA": "N",
            "aN": 353.89
        },
        {
            "title": "    99 Dike (A868 KA)",
            "a": 2.663,
            "i": 13.86,
            "e": 0.1976,
            "peri": 195.48,
            "M": 337.9,
            "period": 1590,
            "q": 2.137,
            "Q": 3.19,
            "NEO": "N",
            "PHA": "N",
            "aN": 41.41
        },
        {
            "title": "   100 Hekate (A868 NA)",
            "a": 3.089,
            "i": 6.43,
            "e": 0.1681,
            "peri": 183.68,
            "M": 250.54,
            "period": 1980,
            "q": 2.57,
            "Q": 3.61,
            "NEO": "N",
            "PHA": "N",
            "aN": 127.17
        },
        {
            "title": "   101 Helena (A868 PA)",
            "a": 2.583,
            "i": 10.19,
            "e": 0.1407,
            "peri": 347.84,
            "M": 228.62,
            "period": 1520,
            "q": 2.22,
            "Q": 2.95,
            "NEO": "N",
            "PHA": "N",
            "aN": 343.37
        },
        {
            "title": "   102 Miriam (A868 QA)",
            "a": 2.662,
            "i": 5.17,
            "e": 0.2508,
            "peri": 147.33,
            "M": 344.57,
            "period": 1590,
            "q": 1.995,
            "Q": 3.33,
            "NEO": "N",
            "PHA": "N",
            "aN": 210.76
        },
        {
            "title": "   103 Hera (A868 RA)",
            "a": 2.704,
            "i": 5.42,
            "e": 0.0796,
            "peri": 189.96,
            "M": 77.41,
            "period": 1620,
            "q": 2.488,
            "Q": 2.92,
            "NEO": "N",
            "PHA": "N",
            "aN": 136.04
        },
        {
            "title": "   104 Klymene (A868 RB)",
            "a": 3.144,
            "i": 2.79,
            "e": 0.1623,
            "peri": 31.81,
            "M": 271.6,
            "period": 2040,
            "q": 2.633,
            "Q": 3.65,
            "NEO": "N",
            "PHA": "N",
            "aN": 41.65
        },
        {
            "title": "   105 Artemis (A868 SA)",
            "a": 2.373,
            "i": 21.45,
            "e": 0.179,
            "peri": 57.02,
            "M": 345.57,
            "period": 1340,
            "q": 1.948,
            "Q": 2.8,
            "NEO": "N",
            "PHA": "N",
            "aN": 188.22
        },
        {
            "title": "   106 Dione (A868 TA)",
            "a": 3.183,
            "i": 4.58,
            "e": 0.1591,
            "peri": 331.69,
            "M": 210.58,
            "period": 2070,
            "q": 2.676,
            "Q": 3.69,
            "NEO": "N",
            "PHA": "N",
            "aN": 61.99
        },
        {
            "title": "   107 Camilla (A868 WA)",
            "a": 3.487,
            "i": 10,
            "e": 0.0655,
            "peri": 304.85,
            "M": 270.87,
            "period": 2380,
            "q": 3.259,
            "Q": 3.72,
            "NEO": "N",
            "PHA": "N",
            "aN": 172.58
        },
        {
            "title": "   108 Hecuba (A869 GB)",
            "a": 3.231,
            "i": 4.21,
            "e": 0.063,
            "peri": 213.21,
            "M": 305.22,
            "period": 2120,
            "q": 3.028,
            "Q": 3.43,
            "NEO": "N",
            "PHA": "N",
            "aN": 349.73
        },
        {
            "title": "   109 Felicitas (A869 TA)",
            "a": 2.693,
            "i": 7.85,
            "e": 0.3004,
            "peri": 57.65,
            "M": 337.52,
            "period": 1610,
            "q": 1.884,
            "Q": 3.5,
            "NEO": "N",
            "PHA": "N",
            "aN": 2.75
        },
        {
            "title": "   110 Lydia (A870 HA)",
            "a": 2.733,
            "i": 5.96,
            "e": 0.0794,
            "peri": 282.22,
            "M": 284.24,
            "period": 1650,
            "q": 2.516,
            "Q": 2.95,
            "NEO": "N",
            "PHA": "N",
            "aN": 56.77
        },
        {
            "title": "   111 Ate (A870 PA)",
            "a": 2.594,
            "i": 4.93,
            "e": 0.1032,
            "peri": 168.3,
            "M": 176.4,
            "period": 1530,
            "q": 2.326,
            "Q": 2.86,
            "NEO": "N",
            "PHA": "N",
            "aN": 305.66
        },
        {
            "title": "   112 Iphigenia (A870 SA)",
            "a": 2.434,
            "i": 2.6,
            "e": 0.1281,
            "peri": 16.91,
            "M": 228.62,
            "period": 1390,
            "q": 2.122,
            "Q": 2.75,
            "NEO": "N",
            "PHA": "N",
            "aN": 323.36
        },
        {
            "title": "   113 Amalthea (A871 EA)",
            "a": 2.376,
            "i": 5.04,
            "e": 0.0859,
            "peri": 80.24,
            "M": 312.59,
            "period": 1340,
            "q": 2.172,
            "Q": 2.58,
            "NEO": "N",
            "PHA": "N",
            "aN": 123.33
        },
        {
            "title": "   114 Kassandra (A871 OA)",
            "a": 2.676,
            "i": 4.94,
            "e": 0.1386,
            "peri": 352.53,
            "M": 151.74,
            "period": 1600,
            "q": 2.305,
            "Q": 3.05,
            "NEO": "N",
            "PHA": "N",
            "aN": 164.05
        },
        {
            "title": "   115 Thyra (A871 PA)",
            "a": 2.38,
            "i": 11.59,
            "e": 0.1925,
            "peri": 96.94,
            "M": 194,
            "period": 1340,
            "q": 1.922,
            "Q": 2.84,
            "NEO": "N",
            "PHA": "N",
            "aN": 308.76
        },
        {
            "title": "   116 Sirona (A871 RA)",
            "a": 2.771,
            "i": 3.56,
            "e": 0.139,
            "peri": 93.78,
            "M": 291.15,
            "period": 1680,
            "q": 2.386,
            "Q": 3.16,
            "NEO": "N",
            "PHA": "N",
            "aN": 63.69
        },
        {
            "title": "   117 Lomia (A871 RB)",
            "a": 2.991,
            "i": 14.92,
            "e": 0.0232,
            "peri": 52.92,
            "M": 168.54,
            "period": 1890,
            "q": 2.922,
            "Q": 3.06,
            "NEO": "N",
            "PHA": "N",
            "aN": 348.63
        },
        {
            "title": "   118 Peitho (A872 EA)",
            "a": 2.437,
            "i": 7.75,
            "e": 0.1635,
            "peri": 33,
            "M": 108.74,
            "period": 1390,
            "q": 2.039,
            "Q": 2.84,
            "NEO": "N",
            "PHA": "N",
            "aN": 47.64
        },
        {
            "title": "   119 Althaea (A872 GA)",
            "a": 2.581,
            "i": 5.79,
            "e": 0.0821,
            "peri": 170.42,
            "M": 107.16,
            "period": 1510,
            "q": 2.369,
            "Q": 2.79,
            "NEO": "N",
            "PHA": "N",
            "aN": 203.62
        },
        {
            "title": "   120 Lachesis (A872 GB)",
            "a": 3.126,
            "i": 6.93,
            "e": 0.0488,
            "peri": 240,
            "M": 225.8,
            "period": 2020,
            "q": 2.974,
            "Q": 3.28,
            "NEO": "N",
            "PHA": "N",
            "aN": 340.68
        },
        {
            "title": "   121 Hermione (A872 JA)",
            "a": 3.455,
            "i": 7.57,
            "e": 0.1252,
            "peri": 297.06,
            "M": 166.58,
            "period": 2350,
            "q": 3.023,
            "Q": 3.89,
            "NEO": "N",
            "PHA": "N",
            "aN": 72.87
        },
        {
            "title": "   122 Gerda (A872 OA)",
            "a": 3.231,
            "i": 1.64,
            "e": 0.0244,
            "peri": 318.91,
            "M": 316.41,
            "period": 2120,
            "q": 3.152,
            "Q": 3.31,
            "NEO": "N",
            "PHA": "N",
            "aN": 178
        },
        {
            "title": "   123 Brunhild (A872 OB)",
            "a": 2.695,
            "i": 6.41,
            "e": 0.1203,
            "peri": 124.73,
            "M": 46.56,
            "period": 1620,
            "q": 2.37,
            "Q": 3.02,
            "NEO": "N",
            "PHA": "N",
            "aN": 307.61
        },
        {
            "title": "   124 Alkeste (A872 QA)",
            "a": 2.629,
            "i": 2.96,
            "e": 0.0783,
            "peri": 61.75,
            "M": 316.59,
            "period": 1560,
            "q": 2.424,
            "Q": 2.84,
            "NEO": "N",
            "PHA": "N",
            "aN": 187.91
        },
        {
            "title": "   125 Liberatrix (A872 RA)",
            "a": 2.742,
            "i": 4.67,
            "e": 0.0813,
            "peri": 109.78,
            "M": 238.01,
            "period": 1660,
            "q": 2.519,
            "Q": 2.96,
            "NEO": "N",
            "PHA": "N",
            "aN": 168.94
        },
        {
            "title": "   126 Velleda (A872 VA)",
            "a": 2.439,
            "i": 2.92,
            "e": 0.1051,
            "peri": 328.36,
            "M": 358.5,
            "period": 1390,
            "q": 2.183,
            "Q": 2.7,
            "NEO": "N",
            "PHA": "N",
            "aN": 23.23
        },
        {
            "title": "   127 Johanna (A872 VB)",
            "a": 2.756,
            "i": 8.24,
            "e": 0.0635,
            "peri": 92.47,
            "M": 356.29,
            "period": 1670,
            "q": 2.581,
            "Q": 2.93,
            "NEO": "N",
            "PHA": "N",
            "aN": 31.1
        },
        {
            "title": "   128 Nemesis (A872 WA)",
            "a": 2.749,
            "i": 6.25,
            "e": 0.1274,
            "peri": 302.82,
            "M": 145.41,
            "period": 1660,
            "q": 2.399,
            "Q": 3.1,
            "NEO": "N",
            "PHA": "N",
            "aN": 76.16
        },
        {
            "title": "   129 Antigone (A873 CA)",
            "a": 2.869,
            "i": 12.27,
            "e": 0.213,
            "peri": 110.6,
            "M": 346.44,
            "period": 1770,
            "q": 2.258,
            "Q": 3.48,
            "NEO": "N",
            "PHA": "N",
            "aN": 135.66
        },
        {
            "title": "   130 Elektra (A873 DA)",
            "a": 3.125,
            "i": 22.78,
            "e": 0.2096,
            "peri": 237.86,
            "M": 302.11,
            "period": 2020,
            "q": 2.47,
            "Q": 3.78,
            "NEO": "N",
            "PHA": "N",
            "aN": 144.97
        },
        {
            "title": "   131 Vala (A873 KA)",
            "a": 2.432,
            "i": 4.96,
            "e": 0.0693,
            "peri": 161.54,
            "M": 348.06,
            "period": 1380,
            "q": 2.263,
            "Q": 2.6,
            "NEO": "N",
            "PHA": "N",
            "aN": 65.56
        },
        {
            "title": "   132 Aethra (A873 LA)",
            "a": 2.612,
            "i": 24.98,
            "e": 0.3868,
            "peri": 255.6,
            "M": 19.7,
            "period": 1540,
            "q": 1.601,
            "Q": 3.62,
            "NEO": "N",
            "PHA": "N",
            "aN": 258.05
        },
        {
            "title": "   133 Cyrene (A873 QA)",
            "a": 3.066,
            "i": 7.21,
            "e": 0.1334,
            "peri": 290.86,
            "M": 146.46,
            "period": 1960,
            "q": 2.658,
            "Q": 3.48,
            "NEO": "N",
            "PHA": "N",
            "aN": 318.92
        },
        {
            "title": "   134 Sophrosyne (A873 SA)",
            "a": 2.564,
            "i": 11.61,
            "e": 0.1151,
            "peri": 85.64,
            "M": 229.3,
            "period": 1500,
            "q": 2.269,
            "Q": 2.86,
            "NEO": "N",
            "PHA": "N",
            "aN": 345.84
        },
        {
            "title": "   135 Hertha (A874 DA)",
            "a": 2.427,
            "i": 2.3,
            "e": 0.2081,
            "peri": 340.38,
            "M": 138.81,
            "period": 1380,
            "q": 1.922,
            "Q": 2.93,
            "NEO": "N",
            "PHA": "N",
            "aN": 343.44
        },
        {
            "title": "   136 Austria (A874 FA)",
            "a": 2.287,
            "i": 9.58,
            "e": 0.0844,
            "peri": 132.93,
            "M": 66.92,
            "period": 1260,
            "q": 2.094,
            "Q": 2.48,
            "NEO": "N",
            "PHA": "N",
            "aN": 186.4
        },
        {
            "title": "   137 Meliboea (A874 HA)",
            "a": 3.123,
            "i": 13.43,
            "e": 0.211,
            "peri": 107.68,
            "M": 35.65,
            "period": 2020,
            "q": 2.464,
            "Q": 3.78,
            "NEO": "N",
            "PHA": "N",
            "aN": 202.17
        },
        {
            "title": "   138 Tolosa (A874 KA)",
            "a": 2.449,
            "i": 3.2,
            "e": 0.1617,
            "peri": 260.7,
            "M": 39.94,
            "period": 1400,
            "q": 2.053,
            "Q": 2.84,
            "NEO": "N",
            "PHA": "N",
            "aN": 54.72
        },
        {
            "title": "   139 Juewa (A874 TA)",
            "a": 2.785,
            "i": 10.87,
            "e": 0.1701,
            "peri": 167.24,
            "M": 335.18,
            "period": 1700,
            "q": 2.311,
            "Q": 3.26,
            "NEO": "N",
            "PHA": "N",
            "aN": 1.67
        },
        {
            "title": "   140 Siwa (A874 TB)",
            "a": 2.734,
            "i": 3.19,
            "e": 0.2162,
            "peri": 197.21,
            "M": 134,
            "period": 1650,
            "q": 2.143,
            "Q": 3.33,
            "NEO": "N",
            "PHA": "N",
            "aN": 107.07
        },
        {
            "title": "   141 Lumen (A875 AA)",
            "a": 2.667,
            "i": 11.89,
            "e": 0.2132,
            "peri": 57.85,
            "M": 252.13,
            "period": 1590,
            "q": 2.098,
            "Q": 3.24,
            "NEO": "N",
            "PHA": "N",
            "aN": 318.45
        },
        {
            "title": "   142 Polana (A875 BA)",
            "a": 2.421,
            "i": 2.24,
            "e": 0.1331,
            "peri": 292.15,
            "M": 206.96,
            "period": 1380,
            "q": 2.099,
            "Q": 2.74,
            "NEO": "N",
            "PHA": "N",
            "aN": 291.09
        },
        {
            "title": "   143 Adria (A875 DA)",
            "a": 2.761,
            "i": 11.44,
            "e": 0.0729,
            "peri": 251.92,
            "M": 151.27,
            "period": 1680,
            "q": 2.56,
            "Q": 2.96,
            "NEO": "N",
            "PHA": "N",
            "aN": 332.96
        },
        {
            "title": "   144 Vibilia (A875 LA)",
            "a": 2.653,
            "i": 4.82,
            "e": 0.2358,
            "peri": 294.47,
            "M": 103.27,
            "period": 1580,
            "q": 2.027,
            "Q": 3.28,
            "NEO": "N",
            "PHA": "N",
            "aN": 76.16
        },
        {
            "title": "   145 Adeona (A875 LB)",
            "a": 2.672,
            "i": 12.62,
            "e": 0.1472,
            "peri": 45.21,
            "M": 189.04,
            "period": 1590,
            "q": 2.278,
            "Q": 3.06,
            "NEO": "N",
            "PHA": "N",
            "aN": 77.32
        },
        {
            "title": "   146 Lucina (A875 LC)",
            "a": 2.718,
            "i": 13.1,
            "e": 0.0658,
            "peri": 145.22,
            "M": 139.68,
            "period": 1640,
            "q": 2.539,
            "Q": 2.9,
            "NEO": "N",
            "PHA": "N",
            "aN": 83.93
        },
        {
            "title": "   147 Protogeneia (A875 NA)",
            "a": 3.138,
            "i": 1.93,
            "e": 0.0223,
            "peri": 103.38,
            "M": 262.44,
            "period": 2030,
            "q": 3.068,
            "Q": 3.21,
            "NEO": "N",
            "PHA": "N",
            "aN": 248.21
        },
        {
            "title": "   148 Gallia (A875 PA)",
            "a": 2.77,
            "i": 25.29,
            "e": 0.1882,
            "peri": 252.43,
            "M": 71.84,
            "period": 1680,
            "q": 2.249,
            "Q": 3.29,
            "NEO": "N",
            "PHA": "N",
            "aN": 144.96
        },
        {
            "title": "   149 Medusa (A875 SA)",
            "a": 2.174,
            "i": 0.94,
            "e": 0.0651,
            "peri": 250.51,
            "M": 122.72,
            "period": 1170,
            "q": 2.033,
            "Q": 2.32,
            "NEO": "N",
            "PHA": "N",
            "aN": 159.62
        },
        {
            "title": "   150 Nuwa (A875 UA)",
            "a": 2.983,
            "i": 2.2,
            "e": 0.1236,
            "peri": 154.17,
            "M": 348.91,
            "period": 1880,
            "q": 2.614,
            "Q": 3.35,
            "NEO": "N",
            "PHA": "N",
            "aN": 206.11
        },
        {
            "title": "   151 Abundantia (A875 VA)",
            "a": 2.592,
            "i": 6.43,
            "e": 0.0358,
            "peri": 132.41,
            "M": 128.98,
            "period": 1520,
            "q": 2.499,
            "Q": 2.68,
            "NEO": "N",
            "PHA": "N",
            "aN": 38.73
        },
        {
            "title": "   152 Atala (A875 VB)",
            "a": 3.137,
            "i": 12.12,
            "e": 0.0825,
            "peri": 58.96,
            "M": 224.93,
            "period": 2030,
            "q": 2.879,
            "Q": 3.4,
            "NEO": "N",
            "PHA": "N",
            "aN": 39.87
        },
        {
            "title": "   153 Hilda (A875 VC)",
            "a": 3.971,
            "i": 7.83,
            "e": 0.1387,
            "peri": 39.32,
            "M": 63.65,
            "period": 2890,
            "q": 3.42,
            "Q": 4.52,
            "NEO": "N",
            "PHA": "N",
            "aN": 228.09
        },
        {
            "title": "   154 Bertha (A875 VD)",
            "a": 3.194,
            "i": 21.02,
            "e": 0.0769,
            "peri": 167.56,
            "M": 273.91,
            "period": 2090,
            "q": 2.949,
            "Q": 3.44,
            "NEO": "N",
            "PHA": "N",
            "aN": 36.49
        },
        {
            "title": "   155 Scylla (A875 VE)",
            "a": 2.761,
            "i": 11.36,
            "e": 0.2727,
            "peri": 46.78,
            "M": 158.11,
            "period": 1680,
            "q": 2.008,
            "Q": 3.51,
            "NEO": "N",
            "PHA": "N",
            "aN": 40.55
        },
        {
            "title": "   156 Xanthippe (A875 WA)",
            "a": 2.733,
            "i": 9.78,
            "e": 0.2238,
            "peri": 338.59,
            "M": 198.86,
            "period": 1650,
            "q": 2.122,
            "Q": 3.35,
            "NEO": "N",
            "PHA": "N",
            "aN": 241.78
        },
        {
            "title": "   157 Dejanira (A875 XA)",
            "a": 2.58,
            "i": 12.16,
            "e": 0.1982,
            "peri": 46.21,
            "M": 305.46,
            "period": 1510,
            "q": 2.069,
            "Q": 3.09,
            "NEO": "N",
            "PHA": "N",
            "aN": 62.03
        },
        {
            "title": "   158 Koronis (A876 AA)",
            "a": 2.868,
            "i": 1.01,
            "e": 0.0533,
            "peri": 147.26,
            "M": 258.96,
            "period": 1770,
            "q": 2.715,
            "Q": 3.02,
            "NEO": "N",
            "PHA": "N",
            "aN": 277.65
        },
        {
            "title": "   159 Aemilia (A876 BA)",
            "a": 3.107,
            "i": 6.11,
            "e": 0.0994,
            "peri": 333.47,
            "M": 34.14,
            "period": 2000,
            "q": 2.798,
            "Q": 3.42,
            "NEO": "N",
            "PHA": "N",
            "aN": 133.86
        },
        {
            "title": "   160 Una (A876 DA)",
            "a": 2.727,
            "i": 3.82,
            "e": 0.0659,
            "peri": 49.95,
            "M": 83.82,
            "period": 1640,
            "q": 2.547,
            "Q": 2.91,
            "NEO": "N",
            "PHA": "N",
            "aN": 8.54
        },
        {
            "title": "   161 Athor (A876 HA)",
            "a": 2.38,
            "i": 9.06,
            "e": 0.1368,
            "peri": 295.06,
            "M": 74.33,
            "period": 1340,
            "q": 2.054,
            "Q": 2.71,
            "NEO": "N",
            "PHA": "N",
            "aN": 18.55
        },
        {
            "title": "   162 Laurentia (A876 HB)",
            "a": 3.015,
            "i": 6.09,
            "e": 0.1825,
            "peri": 115.61,
            "M": 145.09,
            "period": 1910,
            "q": 2.465,
            "Q": 3.57,
            "NEO": "N",
            "PHA": "N",
            "aN": 35.44
        },
        {
            "title": "   163 Erigone (A876 HC)",
            "a": 2.366,
            "i": 4.82,
            "e": 0.1921,
            "peri": 298.38,
            "M": 12.01,
            "period": 1330,
            "q": 1.912,
            "Q": 2.82,
            "NEO": "N",
            "PHA": "N",
            "aN": 160.01
        },
        {
            "title": "   164 Eva (A876 NA)",
            "a": 2.632,
            "i": 24.48,
            "e": 0.3467,
            "peri": 284.05,
            "M": 192.12,
            "period": 1560,
            "q": 1.72,
            "Q": 3.54,
            "NEO": "N",
            "PHA": "N",
            "aN": 76.78
        },
        {
            "title": "   165 Loreley (A876 PA)",
            "a": 3.127,
            "i": 11.23,
            "e": 0.0836,
            "peri": 344.65,
            "M": 303.79,
            "period": 2020,
            "q": 2.865,
            "Q": 3.39,
            "NEO": "N",
            "PHA": "N",
            "aN": 302.43
        },
        {
            "title": "   166 Rhodope (A876 PB)",
            "a": 2.687,
            "i": 12.02,
            "e": 0.2105,
            "peri": 264.13,
            "M": 187.35,
            "period": 1610,
            "q": 2.121,
            "Q": 3.25,
            "NEO": "N",
            "PHA": "N",
            "aN": 128.88
        },
        {
            "title": "   167 Urda (A876 QA)",
            "a": 2.854,
            "i": 2.22,
            "e": 0.0372,
            "peri": 127.52,
            "M": 296.61,
            "period": 1760,
            "q": 2.748,
            "Q": 2.96,
            "NEO": "N",
            "PHA": "N",
            "aN": 166.1
        },
        {
            "title": "   168 Sibylla (A876 SA)",
            "a": 3.374,
            "i": 4.67,
            "e": 0.0748,
            "peri": 176.44,
            "M": 285.88,
            "period": 2260,
            "q": 3.121,
            "Q": 3.63,
            "NEO": "N",
            "PHA": "N",
            "aN": 205.92
        },
        {
            "title": "   169 Zelia (A876 SB)",
            "a": 2.358,
            "i": 5.5,
            "e": 0.1302,
            "peri": 334.81,
            "M": 346.23,
            "period": 1320,
            "q": 2.051,
            "Q": 2.67,
            "NEO": "N",
            "PHA": "N",
            "aN": 354.72
        },
        {
            "title": "   170 Maria (A877 AA)",
            "a": 2.554,
            "i": 14.36,
            "e": 0.0614,
            "peri": 158.54,
            "M": 93.38,
            "period": 1490,
            "q": 2.397,
            "Q": 2.71,
            "NEO": "N",
            "PHA": "N",
            "aN": 301.19
        },
        {
            "title": "   171 Ophelia (A877 AB)",
            "a": 3.129,
            "i": 2.55,
            "e": 0.1324,
            "peri": 55.33,
            "M": 186.58,
            "period": 2020,
            "q": 2.714,
            "Q": 3.54,
            "NEO": "N",
            "PHA": "N",
            "aN": 100.47
        },
        {
            "title": "   172 Baucis (A877 CA)",
            "a": 2.38,
            "i": 10.02,
            "e": 0.1143,
            "peri": 359.23,
            "M": 260.89,
            "period": 1340,
            "q": 2.108,
            "Q": 2.65,
            "NEO": "N",
            "PHA": "N",
            "aN": 331.9
        },
        {
            "title": "   173 Ino (A877 PA)",
            "a": 2.741,
            "i": 14.2,
            "e": 0.2098,
            "peri": 228.57,
            "M": 108.48,
            "period": 1660,
            "q": 2.166,
            "Q": 3.32,
            "NEO": "N",
            "PHA": "N",
            "aN": 148.13
        },
        {
            "title": "   174 Phaedra (A877 RA)",
            "a": 2.86,
            "i": 12.1,
            "e": 0.1449,
            "peri": 290.86,
            "M": 219.76,
            "period": 1770,
            "q": 2.445,
            "Q": 3.27,
            "NEO": "N",
            "PHA": "N",
            "aN": 327.27
        },
        {
            "title": "   175 Andromache (A877 TA)",
            "a": 3.185,
            "i": 3.22,
            "e": 0.2319,
            "peri": 319.75,
            "M": 196.86,
            "period": 2080,
            "q": 2.447,
            "Q": 3.92,
            "NEO": "N",
            "PHA": "N",
            "aN": 21.28
        },
        {
            "title": "   176 Iduna (A877 TB)",
            "a": 3.179,
            "i": 22.68,
            "e": 0.1719,
            "peri": 188.91,
            "M": 325.36,
            "period": 2070,
            "q": 2.632,
            "Q": 3.73,
            "NEO": "N",
            "PHA": "N",
            "aN": 200.46
        },
        {
            "title": "   177 Irma (A877 VA)",
            "a": 2.771,
            "i": 1.38,
            "e": 0.2342,
            "peri": 39.67,
            "M": 321.78,
            "period": 1680,
            "q": 2.122,
            "Q": 3.42,
            "NEO": "N",
            "PHA": "N",
            "aN": 346.93
        },
        {
            "title": "   178 Belisana (A877 VB)",
            "a": 2.462,
            "i": 1.89,
            "e": 0.0418,
            "peri": 213.29,
            "M": 165.1,
            "period": 1410,
            "q": 2.359,
            "Q": 2.57,
            "NEO": "N",
            "PHA": "N",
            "aN": 51.09
        },
        {
            "title": "   179 Klytaemnestra (A877 VC)",
            "a": 2.974,
            "i": 7.82,
            "e": 0.1096,
            "peri": 104.41,
            "M": 294.88,
            "period": 1870,
            "q": 2.648,
            "Q": 3.3,
            "NEO": "N",
            "PHA": "N",
            "aN": 251.83
        },
        {
            "title": "   180 Garumna (A878 BA)",
            "a": 2.72,
            "i": 0.87,
            "e": 0.1683,
            "peri": 175.91,
            "M": 240.57,
            "period": 1640,
            "q": 2.262,
            "Q": 3.18,
            "NEO": "N",
            "PHA": "N",
            "aN": 311.83
        },
        {
            "title": "   181 Eucharis (A878 CB)",
            "a": 3.125,
            "i": 18.9,
            "e": 0.2082,
            "peri": 318.86,
            "M": 207.33,
            "period": 2020,
            "q": 2.474,
            "Q": 3.78,
            "NEO": "N",
            "PHA": "N",
            "aN": 142.98
        },
        {
            "title": "   182 Elsa (A878 CC)",
            "a": 2.415,
            "i": 2.01,
            "e": 0.1868,
            "peri": 310.51,
            "M": 87.47,
            "period": 1370,
            "q": 1.964,
            "Q": 2.87,
            "NEO": "N",
            "PHA": "N",
            "aN": 107.17
        },
        {
            "title": "   183 Istria (A878 CD)",
            "a": 2.795,
            "i": 26.39,
            "e": 0.3483,
            "peri": 264.09,
            "M": 208.33,
            "period": 1710,
            "q": 1.822,
            "Q": 3.77,
            "NEO": "N",
            "PHA": "N",
            "aN": 141.84
        },
        {
            "title": "   184 Dejopeja (A878 DA)",
            "a": 3.196,
            "i": 1.13,
            "e": 0.0595,
            "peri": 216.93,
            "M": 271.85,
            "period": 2090,
            "q": 3.005,
            "Q": 3.39,
            "NEO": "N",
            "PHA": "N",
            "aN": 330.21
        },
        {
            "title": "   185 Eunike (A878 EA)",
            "a": 2.739,
            "i": 23.25,
            "e": 0.1271,
            "peri": 223.93,
            "M": 260.06,
            "period": 1660,
            "q": 2.391,
            "Q": 3.09,
            "NEO": "N",
            "PHA": "N",
            "aN": 153.74
        },
        {
            "title": "   186 Celuta (A878 GA)",
            "a": 2.362,
            "i": 13.19,
            "e": 0.1493,
            "peri": 315.59,
            "M": 9.9,
            "period": 1330,
            "q": 2.009,
            "Q": 2.71,
            "NEO": "N",
            "PHA": "N",
            "aN": 14.71
        },
        {
            "title": "   187 Lamberta (A878 GB)",
            "a": 2.728,
            "i": 10.58,
            "e": 0.24,
            "peri": 196.69,
            "M": 154.07,
            "period": 1650,
            "q": 2.073,
            "Q": 3.38,
            "NEO": "N",
            "PHA": "N",
            "aN": 21.67
        },
        {
            "title": "   188 Menippe (A878 MA)",
            "a": 2.762,
            "i": 11.7,
            "e": 0.1788,
            "peri": 69.74,
            "M": 271.59,
            "period": 1680,
            "q": 2.268,
            "Q": 3.26,
            "NEO": "N",
            "PHA": "N",
            "aN": 240.82
        },
        {
            "title": "   189 Phthia (A878 RA)",
            "a": 2.451,
            "i": 5.18,
            "e": 0.0364,
            "peri": 169.81,
            "M": 26.03,
            "period": 1400,
            "q": 2.362,
            "Q": 2.54,
            "NEO": "N",
            "PHA": "N",
            "aN": 203.34
        },
        {
            "title": "   190 Ismene (A878 SA)",
            "a": 3.995,
            "i": 6.17,
            "e": 0.1683,
            "peri": 271.3,
            "M": 146.33,
            "period": 2920,
            "q": 3.322,
            "Q": 4.67,
            "NEO": "N",
            "PHA": "N",
            "aN": 175.42
        },
        {
            "title": "   191 Kolga (A878 SB)",
            "a": 2.896,
            "i": 11.52,
            "e": 0.0873,
            "peri": 226.56,
            "M": 206.93,
            "period": 1800,
            "q": 2.644,
            "Q": 3.15,
            "NEO": "N",
            "PHA": "N",
            "aN": 159.18
        },
        {
            "title": "   192 Nausikaa (A879 DA)",
            "a": 2.403,
            "i": 6.8,
            "e": 0.2456,
            "peri": 30.58,
            "M": 167.54,
            "period": 1360,
            "q": 1.813,
            "Q": 2.99,
            "NEO": "N",
            "PHA": "N",
            "aN": 343.09
        },
        {
            "title": "   193 Ambrosia (A879 DB)",
            "a": 2.598,
            "i": 12,
            "e": 0.2983,
            "peri": 82.57,
            "M": 315.45,
            "period": 1530,
            "q": 1.823,
            "Q": 3.37,
            "NEO": "N",
            "PHA": "N",
            "aN": 349.49
        },
        {
            "title": "   194 Prokne (A879 FA)",
            "a": 2.616,
            "i": 18.51,
            "e": 0.2371,
            "peri": 163.21,
            "M": 21.23,
            "period": 1550,
            "q": 1.996,
            "Q": 3.24,
            "NEO": "N",
            "PHA": "N",
            "aN": 159.25
        },
        {
            "title": "   195 Eurykleia (A879 HA)",
            "a": 2.878,
            "i": 6.96,
            "e": 0.0389,
            "peri": 117.99,
            "M": 0.29,
            "period": 1780,
            "q": 2.766,
            "Q": 2.99,
            "NEO": "N",
            "PHA": "N",
            "aN": 6.87
        },
        {
            "title": "   196 Philomela (A879 JA)",
            "a": 3.112,
            "i": 7.26,
            "e": 0.0144,
            "peri": 203.41,
            "M": 86.86,
            "period": 2010,
            "q": 3.067,
            "Q": 3.16,
            "NEO": "N",
            "PHA": "N",
            "aN": 72.3
        },
        {
            "title": "   197 Arete (A879 KA)",
            "a": 2.74,
            "i": 8.79,
            "e": 0.1628,
            "peri": 245.99,
            "M": 313.16,
            "period": 1660,
            "q": 2.294,
            "Q": 3.19,
            "NEO": "N",
            "PHA": "N",
            "aN": 81.56
        },
        {
            "title": "   198 Ampella (A879 LA)",
            "a": 2.458,
            "i": 9.32,
            "e": 0.2275,
            "peri": 89.08,
            "M": 177.53,
            "period": 1410,
            "q": 1.899,
            "Q": 3.02,
            "NEO": "N",
            "PHA": "N",
            "aN": 268.2
        },
        {
            "title": "   199 Byblis (A879 NA)",
            "a": 3.161,
            "i": 15.48,
            "e": 0.1832,
            "peri": 179.52,
            "M": 252.44,
            "period": 2050,
            "q": 2.582,
            "Q": 3.74,
            "NEO": "N",
            "PHA": "N",
            "aN": 88.42
        },
        {
            "title": "   200 Dynamene (A879 OA)",
            "a": 2.737,
            "i": 6.9,
            "e": 0.1331,
            "peri": 87.14,
            "M": 301.21,
            "period": 1650,
            "q": 2.372,
            "Q": 3.1,
            "NEO": "N",
            "PHA": "N",
            "aN": 324.24
        }
    ]
}